const mixins = {
  content: {
    width: 1410,
    height: 1000,
  },
  kioskHNavigation: {
    height: 840,
    width: 390,
  },
  aside: {
    width: 390,
  },
  collapsedContent: {
    width: 1225,
  },
  expandedContent: {
    width: 591,
  },
}

export const themeOptionFactory = (theme) => ({
  assets: {
    loadingScreen: {
      url: "https://s3.venue.in.th/Logo_78f1db8fcb.png",
    },
  },
  components: {
    MuiToggleButtonGroup: {
      styleOverrides: {
        grouped: {
          "&:not(:last-of-type)": {
            borderRadius: "32px",
          },
          "&:not(:first-of-type)": {
            marginLeft: "unset",
            borderLeft: `1px solid ${theme.palette.divider}`,
            borderRadius: "32px",
          },
        },
      },
      variants: [
        {
          props: { variant: "borderSeperate" },
          style: {
            "& .MuiToggleButtonGroup-grouped:not(:first-of-type)": {
              border: "1px solid #E2E2E4",
            },
          },
        },
      ],
    },
    MuiCssBaseline: {
      styleOverrides: {
        ".maptalks-canvas-layer": {
          backgroundColor: theme.palette.common.white,
        },
        body: {
          overflow: "hidden",
          background:
            "url(https://s3.venue.in.th/bg_kioskh_1_8e9e4008ab.png) no-repeat center/cover, linear-gradient(0deg, #F4F3F3, #F4F3F3), linear-gradient(0deg, #FFFFFF, #FFFFFF), linear-gradient(180deg, #F8F8FF 5.51%, rgba(248, 248, 255, 0) 41.3%) #df0000",
          '&[dir="rtl"]': {
            background:
              "url(https://s3.venue.in.th/bg_kioskh_1_8e9e4008ab.png) no-repeat center/cover, linear-gradient(0deg, #F4F3F3, #F4F3F3), linear-gradient(0deg, #FFFFFF, #FFFFFF), linear-gradient(180deg, #F8F8FF 5.51%, rgba(248, 248, 255, 0) 41.3%) #df0000",
            transform: "scaleX(-1)",
          },

          "&.is-open-sidebar": {
            "& #map": {
              marginLeft: `${
                mixins.collapsedContent.width - mixins.content.width
              }px`,
            },
            "& .AppLayout-indoorMapWrapper": {
              width: mixins.collapsedContent.width,
            },
            "& .ContentWithAside-contentWrapper": {
              width: mixins.collapsedContent.width,
            },
            "& .ContentWithAside-asideWrapper": {
              width: mixins.expandedContent.width,
            },
          },
        },
        ".hidden-sidebar": {
          "& .ContentWithAside-contentWrapper": {
            width: "100%",
          },
          "& .ContentWithAside-asideWrapper": {
            display: "none",
          },
          "& .MainCarouselNavigation-root": {
            display: "none",
          },
        },
        ".is-rtl": {
          "& .MuiSvgIcon-root": {
            transform: "rotate(180deg) !important",
          },
        },
        "@keyframes fadeIn": {
          "0%": {
            opacity: 0,
          },
          "100%": {
            opacity: 1,
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          width: "48px",
          height: "28px",
          padding: 0,
          margin: theme.spacing(1),
          display: "flex",
          alignItems: "center",
          "& .MuiSwitch-thumb": {
            width: "22px",
            height: "22px",
          },
          "&:active": {
            "& .MuiSwitch-thumb": {
              width: "22px",
            },
            "& .MuiSwitch-switchBase.Mui-checked": {
              transform: "translateX(9px)",
            },
          },
          "& .MuiSwitch-switchBase": {
            padding: theme.spacing(0.375),
            "&.Mui-checked": {
              transform: "translateX(20px)",
              "& + .MuiSwitch-track": {
                opacity: 1,
                backgroundColor: theme.palette.primary.main,
              },
            },
          },
        },
      },
    },
    LoadingScreen: {
      styleOverrides: {
        logo: {
          width: "500px",
        },
        loadingRoot: {
          position: "relative",
        },
        loadingTrack: {
          color: theme.palette.grey[200],
        },
        loadingIndicator: {
          color: "#E3D7AA",
          animationDuration: "3000ms",
          position: "absolute",
          left: 0,
          [`& .MuiCircularProgress-circle`]: {
            strokeLinecap: "round",
          },
        },
      },
    },
    AppMap: {
      styleOverrides: {
        indoorMapContainer: {
          "& #map": {
            marginLeft: 0,
            width: mixins.content.width,
            height: mixins.content.height,
          },
        },
        toolbarContainer: {
          position: "fixed",
          bottom: "60px",
          display: "flex",
          flexDirection: "column",
          width: "unset",
        },
        quickLinkContainer: {
          //hide scrollbar
          "::-webkit-scrollbar": {
            display: "none",
          },
          padding: theme.spacing(0, 0, 0, 5),
          overflowX: "scroll",
          MsOverflowStyle: "none",
          scrollbarWidth: "none",
          display: "flex",
          order: 0,
          "&:after": {
            display: "none",
          },
          "&:before": {
            display: "none",
          },
          "& .MuiTabs-scroller": {
            width: "1114px",
          },
          "& .MuiToggleButtonGroup-root": {
            height: "56px",
          },
        },
        ordinalSelector: {
          display: "inline-flex",
          position: "absolute",
          bottom: "300px",
          right: "30px",
          marginBottom: theme.spacing(3),
          zIndex: theme.zIndex.modal - 1,
        },
        locationButtonContainer: {
          display: "flex",
          position: "absolute",
          bottom: "208px",
          right: "30px",
          flexDirection: "column",
          gap: "20px",
          marginBottom: theme.spacing(2.75),
        },
        attractionButtonContainer: {
          display: "flex",
          position: "absolute",
          bottom: 0,
          right: "20px",
          flexDirection: "column",
          gap: "20px",
          marginBottom: theme.spacing(3.25),
        },
        touristRegistrationPanelWrapper: {
          width: 300,
          height: 300,
          position: "relative",
          top: 600,
          overflow: "hidden",
          pointerEvents: "none !important",
        },
        sideBannerPanelWrapper: {
          width: 300,
          height: 300,
          position: "relative",
          top: 52,
          overflow: "hidden",
          pointerEvents: "none !important",
        },
      },
    },
    AppLayout: {
      styleOverrides: {
        headerWrapper: {
          display: "none",
        },
        indoorMapWrapper: {
          top: 0,
          width: mixins.content.width,
          maxWidth: mixins.content.width,
          transition: `all ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut} ${theme.transitions.duration.shortest}ms`,
          borderRadius: "32px",
          margin: theme.spacing(5),
        },
      },
    },
    AppContentWithAside: {
      styleOverrides: {
        root: {
          height: "100dvh",
          display: "flex",
          width: "100dvw",
          padding: theme.spacing(5),
          gap: theme.spacing(5),
        },
        contentWrapper: {
          width: mixins.content.width,
          position: "relative",
          flexShrink: 0,
          transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut} ${theme.transitions.duration.shortest}ms`,
        },
        asideWrapper: {
          position: "relative",
          marginTop: theme.spacing(-5), // Fix aside panel to stay closed at the top of the viewport
          width: mixins.aside.width,
          flexShrink: 0,
          transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut} ${theme.transitions.duration.shortest}ms`,
          "&>.MuiPaper-root": {
            background: "transparent",
          },
        },
      },
    },
    AppPageLayout: {
      styleOverrides: {
        root: {
          height: "100%",
        },
      },
    },
    AttractionButton: {
      styleOverrides: {
        root: {
          width: 188,
          height: 188,
          position: "relative",
          cursor: "pointer",
        },
        carousel: {
          width: 188,
          height: 188,
          borderRadius: "50%",
          overflow: "hidden",
          border: "2px solid transparent",
          boxShadow:
            "33px 36px 14px 0px rgba(0, 0, 0, 0.00), 21px 23px 13px 0px rgba(0, 0, 0, 0.01), 12px 13px 11px 0px rgba(0, 0, 0, 0.04), 5px 6px 8px 0px rgba(0, 0, 0, 0.06), 1px 1px 4px 0px rgba(0, 0, 0, 0.07)",
          background:
            "linear-gradient(180deg, #FFFFFF 38.03%, #EDEEEE 100%, #FFF) padding-box, linear-gradient(333deg, #C8AF55 31.92%, #EEE7CC 81.85%) border-box",
          "& .splide": {
            height: "100%",
          },
          "& .splide__track": {
            height: "100%",
            padding: theme.spacing(1.25),
            margin: 0,
          },
          "&:after": {
            content: "''",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            margin: theme.spacing(1.375),
            borderRadius: "50%",
            background:
              "linear-gradient(180deg, rgba(0, 0, 0, 0.1) 46.17%, rgba(0, 0, 0, 0.84) 85.67%)",
            pointerEvents: "none",
          },
        },
        carouselItem: {
          width: "100%",
          height: "100%",
          borderRadius: "50%",
        },
        image: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "50%",
        },
        attractionText: {
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          color: theme.palette.secondary.contrastText,
          fontWeight: 700,
          fontSize: "1.5rem",
          zIndex: 10,
          padding: theme.spacing(0.5, 1.5),
          borderRadius: "16px",
          textShadow: "1px 1px 4px rgba(0,0,0,0.8)",
          pointerEvents: "none",
        },
      },
    },
    BaseModal: {
      styleOverrides: {
        root: {},
        container: {
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        },
        closeIconButton: {
          position: "absolute",
          background: "#F8F8FF",
          border: `1px solid ${theme.palette.divider}`,
          width: "82px",
          height: "82px",
          top: "12px",
          right: "calc(10% - 12px)",
          borderRadius: "50%",
          ":hover": {
            background: "#F8F8FF",
          },
          marginTop: 0,
        },
        closeIcon: {
          width: "20px",
          height: "20px",
        },
      },
    },
    IframeModal: {
      defaultProps: {
        iframeOptions: {},
      },
      styleOverrides: {
        root: {
          "& .BaseModal-closeButton": {
            marginTop: theme.spacing(-1.5),
          },
          "&.IframeModal-transportation-iframe iframe": {
            width: "82vw",
            height: "1080px",
            transform: "scale(0.93)",
          },
        },
        contentContainer: {},
        iframe: {
          // !Fix: Prevent non-responsive sites from overflowing the horizontal edges of the iframe.
          width: "100%",
          height: "100%",
          backgroundColor: theme.palette.background.paper,
          borderRadius: "20px",
        },
      },
    },
    AttractionModal: {
      defaultProps: {
        scrollableTabProps: {
          orientation: "vertical",
        },
      },
      styleOverrides: {
        root: {
          height: "934px",
          width: "1395px",
          backgroundColor: theme.palette.background.paper,
          borderRadius: "24px",
          position: "relative",
          display: "flex",
          flexDirection: "row",
          overflow: "hidden",
        },
        contentContainer: {
          width: "100%",
          height: "934px",
          position: "relative",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          "&:after": {
            pointerEvents: "none",
            content: "''",
            position: "absolute",
            width: "100%",
            top: 0,
            bottom: 0,
            right: 0,
            background:
              "linear-gradient(180deg, rgba(0, 0, 0, 0.1) 46.17%, rgba(0, 0, 0, 0.84) 88.72%)",
          },
        },
        image: {
          width: "100%",
          height: "100%",
          position: "absolute",
          objectFit: "cover",
          background: theme.palette.background.paper,
        },
        informationWrapper: {
          width: "100%",
          minHeight: "226px",
          display: "flex",
          justifyContent: "space-between",
          padding: theme.spacing(4),
          zIndex: 2,
        },
        textContentWrapper: {
          padding: theme.spacing(3),
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1.5),
          maxWidth: "500px",
          overflow: "hidden",
        },
        titleText: {
          color: theme.palette.primary.contrastText,
          fontWeight: 700,
          fontSize: "2rem",
        },
        descriptionText: {
          color: theme.palette.primary.contrastText,
          fontSize: "1.25rem",
          paddingLeft: theme.spacing(3),
          fontWeight: 400,
          borderLeft: "4px solid #AC8700",
          overflow: "hidden",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 3,
        },
        buttonContainer: {
          display: "flex",
          alignItems: "flex-end",
        },
        locationButton: {
          width: "188px",
          height: "80px",
          background:
            "url(https://s3.venue.in.th/Button_188_px_78d4edf6c5.png) center/contain no-repeat",
          color: theme.palette.primary.contrastText,
          fontWeight: "500",
          fontSize: "20px",
          padding: theme.spacing(1, 1.5),
          borderRadius: "20px",
        },
        locationWrapper: {
          height: "934px",
          width: "252px",
          backgroundColor: "#F3F3F4",
          position: "relative",
          flexShrink: 0,
        },
        tabContainer: {
          width: "100%",
          height: "100%",
          "& .MuiTabs-root": {
            width: "100%",
            height: "100%",
          },
          "& .MuiTabs-scroller": {
            width: "100%",
          },
          '[dir="rtl"] &': {
            "& .MuiTabs-scrollButtons": {
              "& .MuiSvgIcon-root": {
                transform: "scaleX(-1)",
              },
            },
          },
        },
        tabLabelContainer: {
          textAlign: "center",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          height: "100%",
          width: "100%",
        },
        locationNameText: {
          maxWidth: "110px",
          fontSize: "1.2rem",
          alignItems: "center",
          textOverflow: "ellipsis",
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
        },
        levelText: {
          width: 40,
          height: 40,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: theme.palette.primary.contrastText,
          fontSize: "1.25rem",
          fontWeight: 500,
          background:
            "url(https://s3.venue.in.th/level_grey_6f54b2cf30.svg) , no-repeat",
        },
        tabItem: {
          width: "100%",
          height: "140px",
          color: theme.palette.common.black,
          padding: theme.spacing(4),
          position: "relative",
          "&::after": {
            content: '""',
            position: "absolute",
            bottom: 0,
            right: 0,
            left: 0,
            width: "100%",
            height: "1px",
            background:
              "linear-gradient(90deg, rgba(255, 255, 255, 0) 1.98%, rgba(234, 234, 236, 0.716316) 8.5%, #8C8A94 48.24%, rgba(235, 235, 237, 0.672713) 92.76%, rgba(255, 255, 255, 0) 100%)",
            zIndex: 1,
          },
          "&.Mui-selected": {
            background: "linear-gradient(0deg, #AC8700 0%, #BA9B2A 88.96%)",
            color: theme.palette.primary.contrastText,
            fontWeight: 500,
            "& .level-text": {
              color: theme.palette.primary.main,
              background:
                "url(https://s3.venue.in.th/ics_level_button_pattern_c3818c9801.svg) no-repeat center / cover",
            },
            "& .attraction-name": {
              fontWeight: 500,
            },
          },
        },
      },
    },
    SidebarMenu: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          height: "100%",
          width: "100%",
          transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut} ${theme.transitions.duration.shortest}ms`,
          gap: 0,
        },
        headerContainer: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          padding: theme.spacing(5),
          position: "relative",
          width: "100%",
          height: "186px",
          minHeight: "186px",
          background:
            "transparent url(https://s3.venue.in.th/header_sidebar_kioskh_1cf1f484a2.png) center top / cover no-repeat",
        },
        headerLogo: {
          width: "212px",
          height: "66px",
          background:
            "transparent url(https://s3.venue.in.th/header_logo_sidebar_kioskh_d6621cc7df.png) center / contain no-repeat",
        },
        navigationContainer: {
          flex: "1 1 0%",
          width: "100%",
          height: "810px",
          minHeight: "810px",
          maxHeight: "unset",
          marginTop: theme.spacing(-4),
        },
        toolbarContainer: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(2),
          marginTop: theme.spacing(1.5),
          padding: 0,
        },
        actionButton: {},
      },
    },
    CarouselNavigation: {
      defaultProps: {
        carouselOption: {
          direction: "ttb",
          drag: true,
          autoHeight: true,
          height: `${mixins.kioskHNavigation.height - 80}px`,
          width: `${mixins.kioskHNavigation.width}px`,
        },
      },
      styleOverrides: {
        root: {
          margin: theme.spacing(14.5, 5, 14.5),
          position: "fixed",
          top: 0,
          bottom: 0,
          right: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          maskImage:
            "linear-gradient(to bottom, transparent, black 16%, black 82%, transparent)",
          "&.ics .CarouselNavigation-carouselItem[link^='/luxury']": {
            pointerEvents: "none",
            "& .CarouselNavigationMenu-root": {
              color: "#C6C5C9",
              "&:before": {
                border: "1px solid #E2E2E4",
                background: "#E2E2E4",
              },
              "& .MuiSvgIcon-root *": {
                fill: "currentColor",
              },
              "& .MuiBottomNavigationAction-label": {
                color: "inherit",
              },
            },
          },
        },
        carousel: {
          "& .splide__track": {
            margin: 0,
            padding: 0,
          },
        },
        carouselItem: {
          "&:after": {
            content: "''",
            position: "absolute",
            left: "0",
            zIndex: -3,
            width: "222px",
            height: "74px",
            opacity: 0,
            borderTop: "1px solid #EEE7CC",
            borderBottom: "1px solid #EEE7CC",
            top: "50%",
            transform: "translateY(-50%)",
            transition: "left 250ms ease-out, opacity 250ms ease-out 100ms",
            background:
              "linear-gradient(270deg, rgba(238, 231, 204, 0.20) 2.25%, rgba(172, 135, 0, 0.20) 52.88%, rgba(238, 231, 204, 0.20) 100%), linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, #FFF 13.54%, #FFF 86.06%, rgba(255, 255, 255, 0.00) 100%)",
          },
          "&.is-active": {
            "&:after": {
              left: "26%",
              opacity: 1,
            },
          },
          "&:not(.is-visible)": {
            opacity: 0,
          },
          "&.is-move": {
            opacity: 1,
          },
        },
      },
    },
    CarouselNavigationMenu: {
      styleOverrides: {
        root: {
          right: "26%",
          gap: theme.spacing(1.25),
          padding: 0,
          maxWidth: "356px",
          width: "390px",
          height: "135px",
          margin: theme.spacing(-2, 0),
          "& .MuiSvgIcon-root": {
            transition: "width 250ms ease, height 250ms ease",
            width: "40px",
            height: "40px",
            margin: 0,
          },
          "& .MuiBottomNavigationAction-label": {
            transition: "all 250ms ease",
            position: "absolute",
            fontSize: "1.5rem",
            textTransform: "capitalize",
            color: theme.palette.text.primary,
            opacity: 1,
            left: "244px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
            lineHeight: 1.8,
            alignContent: "center",
          },
          "&:before": {
            transition: "width 250ms ease, height 250ms ease",
            content: "''",
            zIndex: -1,
            position: "absolute",
            width: "95px",
            height: "95px",
            transform: "rotate(-45deg)",
            borderRadius: "24px",
            border: "1px solid #C8AF55",
            background: theme.palette.background.paper,
            boxShadow:
              "33px 36px 14px 0px rgba(0, 0, 0, 0.00), 21px 23px 13px 0px rgba(0, 0, 0, 0.01), 12px 13px 11px 0px rgba(0, 0, 0, 0.04), 5px 6px 8px 0px rgba(0, 0, 0, 0.06), 1px 1px 4px 0px rgba(0, 0, 0, 0.07)",
          },
          "& .MuiTouchRipple-root": {
            width: "100px",
            height: "100px",
            borderRadius: "20px",
            transform: "rotate(-45deg)",
            margin: "auto",
          },
          "&.Mui-selected": {
            zIndex: 1,
            color: theme.palette.primary.main,
            backgroundColor: "transparent",
            "& .MuiBottomNavigationAction-label": {
              left: "260px",
              fontSize: "1.5rem",
              fontWeight: 700,
              color: theme.palette.primary.main,
            },
            "&:before": {
              content: "''",
              zIndex: -1,
              position: "absolute",
              width: "120px",
              height: "120px",
              transform: "rotate(-45deg)",
              borderRadius: "20px",
              borderBottom: "5px solid #ccb561",
              background:
                "url(https://s3.venue.in.th/pattern_menu_08c025162a.png) no-repeat center center / cover, linear-gradient(15deg, #AC8700 5.88%, #E9CA76 84.96%), linear-gradient(15deg, #AC8700 5.88%, #C8AF55 84.96%)",
              boxShadow:
                "33px 36px 14px 0px rgba(0, 0, 0, 0.00), 21px 23px 13px 0px rgba(0, 0, 0, 0.01), 12px 13px 11px 0px rgba(0, 0, 0, 0.04), 5px 6px 8px 0px rgba(0, 0, 0, 0.06), 1px 1px 4px 0px rgba(0, 0, 0, 0.07)",
            },
            "& .MuiSvgIcon-root": {
              width: "72px",
              height: "72px",
            },
          },
        },
      },
    },
    ScrollableTab: {
      styleOverrides: {
        root: {},
        scrollContainer: {
          display: "flex",
          alignItems: "center",
          position: "relative",
          "& .MuiTabs-indicator": {
            display: "none",
          },
          "& .MuiTabs-scrollButtons": {
            display: "flex",
            zIndex: 2,
            margin: theme.spacing(1.5),
            "&.Mui-disabled": {
              opacity: 0,
              visibility: "hidden",
            },
          },
          "&:not(.MuiTabs-vertical) .MuiTabs-scrollButtons": {
            position: "absolute",
            top: "unset",
            "&:first-of-type": {
              left: 0,
            },
            "&:last-of-type": {
              right: 0,
            },
          },
          "&.MuiTabs-vertical .MuiTabs-scrollButtons": {
            transform: "rotate(90deg)",
            position: "absolute",
            "&:first-of-type": {
              top: 0,
            },
            "&:last-of-type": {
              bottom: 0,
            },
          },
          "& .MuiTabs-scroller": {
            height: "auto",
          },
        },
        iconButton: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 40,
          height: 40,
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "50%",
          fill: theme.palette.text.secondary,
          "&:hover": {
            backgroundColor: theme.palette.background.paper,
          },
        },
      },
    },
    SubCategorySidebar: {
      styleOverrides: {
        root: {
          width: "222px",
          height: "884px",
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "24px",
          boxShadow:
            "29px 28px 11px 0px rgba(0, 0, 0, 0.00), 18px 18px 10px 0px rgba(0, 0, 0, 0.01), 10px 10px 9px 0px rgba(0, 0, 0, 0.02), 5px 4px 6px 0px rgba(0, 0, 0, 0.04), 1px 1px 4px 0px rgba(0, 0, 0, 0.04);",
          padding: theme.spacing(2.5),
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(4),
          transformOrigin: "left center",
          zIndex: 10,
        },
        mainCategoryWrapper: {
          minWidth: "182px",
          minHeight: "182px",
          background:
            "linear-gradient(333deg, rgba(200, 175, 85, 0.40) 9.48%, rgba(238, 231, 204, 0.40) 69.55%)",
          borderRadius: "16px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: theme.spacing(1),
          padding: theme.spacing(1.5),
        },
        mainCategoryLabel: {
          fontWeight: 700,
          color: theme.palette.primary.main,
          textAlign: "center",
        },
        icon: {
          "& .MuiSvgIcon-root": {
            width: "60px",
            height: "60px",
            fill: theme.palette.primary.main,
          },
        },
        subCategoryWrapper: {
          overflowX: "hidden",
          overflowY: "auto",
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#8C8A94",
            borderRadius: "9999px",
          },
          "& .MuiToggleButton-root": {
            height: "auto",
            minHeight: "40px",
            width: "fit-content",
            textAlign: "left",
            "& .MuiTypography-root": {
              whiteSpace: "normal",
              wordBreak: "break-word",
              lineHeight: 1.2,
            },
          },
        },
      },
    },
    VenueSelector: {
      styleOverrides: {
        root: {
          display: "flex",
          justifyContent: "space-between",
          height: "64px",
          width: "304px",
          background: "#ECECED",
          border: `2px solid ${theme.palette.background.paper}`,
          borderRadius: "64px",
          padding: theme.spacing(0.5),
          gap: 0,
          boxShadow:
            "0px 45px 13px 0px rgba(0, 0, 0, 0.00), 0px 29px 11px 0px rgba(0, 0, 0, 0.01), 0px 16px 10px 0px rgba(0, 0, 0, 0.05), 0px 7px 7px 0px rgba(0, 0, 0, 0.09), 0px 2px 4px 0px rgba(0, 0, 0, 0.10)",
        },
        buttonWrapper: {
          height: "100%",
          transition: "none",
          "&.selected": {
            transform: "none",
            margin: 0,
          },
          "&.all": {
            order: 1,
          },
          "&.iconsiam": {
            order: 2,
          },
          "&.ics": {
            order: 3,
          },
        },
        button: {
          height: "auto",
          width: 98,
          display: "flex",
          justifyContent: "center",
          padding: theme.spacing(1, 1.5),
          borderRadius: "64px",
          backgroundColor: "transparent",
          "&.Mui-selected": {
            border: "1px solid #EDEEEE",
            background: "linear-gradient(180deg, #FFFFFF 38.03%, #EDEEEE 100%)",
            "&:hover": {
              background:
                "linear-gradient(180deg, #FFFFFF 38.03%, #EDEEEE 100%)",
              border: "1px solid #EDEEEE",
            },
          },
          "& .MuiAvatar-root": {
            borderRadius: 0,
          },
        },
        allVenueIcon: {
          display: "none",
        },
        icon: {
          height: "32px",
          width: "72px",
          "& img": {
            objectFit: "contain",
          },
        },
        allVenueLabel: {
          display: "flex",
          color: theme.palette.primary.main,
          fontSize: "1.25rem",
          fontWeight: 300,
          ".Mui-selected &": {
            fontWeight: 500,
          },
        },
        currentVenueChip: {
          display: "none",
        },
      },
    },
    DirectoryPage: {
      styleOverrides: {
        pageCardContent: {
          padding: theme.spacing(0, 13.5),
          background:
            "url(https://s3.venue.in.th/floorplan_bg_iconsiam_kiosk_h_1f69ed0abe.svg) no-repeat center/cover",
          "&:last-of-type": {
            paddingBottom: 0,
          },
        },
        contentBox: {
          display: "flex",
        },
        emptyDataWrapper: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          left: "unset",
          top: "unset",
          minHeight: "884px",
          width: "100%",
          transform: "unset",
        },
        gridItem: {
          width: "222px",
        },
        gridContainer: {
          gap: theme.spacing(2.5),
          padding: 0,
          gridTemplateRows: "repeat(4, max-content)",
          gridTemplateColumns: "repeat(5, minmax(100px, 1fr))",
          minHeight: 0,
          height: "initial",
          gridAutoFlow: "row",
          overflow: "initial",
        },
        gridContainerWrapper: {
          height: "884px",
          overflow: "hidden auto",
          scrollbarWidth: "none",
          paddingBottom: theme.spacing(15),
        },
        filterSection: {
          paddingTop: 0,
          top: "unset",
          marginTop: "auto",
          "& .category-filterbar,& .subCategory-filterbar": {
            overflow: "hidden",
            maxWidth: "100%",
            padding: 0,
            margin: 0,
            "&:after": {
              width: "80px",
              background:
                "linear-gradient(270deg, #F8F8FF 0%, rgba(248, 248, 255, 0.00) 100%)",
              right: 0,
              pointerEvents: "none",
            },
            "&:before": {
              display: "none",
            },
          },
          "&:before": {
            display: "none",
          },
        },
        categoryFilterBar: {
          gap: theme.spacing(3),
          margin: 0,
          padding: 0,
          "& .MuiToggleButton-root": {
            width: "92px",
            height: "92px",
            gap: theme.spacing(1),
            padding: theme.spacing(1),
            justifyContent: "flex-start",
            "& .MuiTypography-root": {
              fontSize: "0.75rem",
              width: "76px",
            },
            "&.Mui-selected": {
              backgroundColor:
                "linear-gradient(333deg, rgba(200, 175, 85, 0.40) 9.48%, rgba(238, 231, 204, 0.40) 69.55%)",
              ":hover": {
                backgroundColor:
                  "linear-gradient(333deg, rgba(200, 175, 85, 0.40) 9.48%, rgba(238, 231, 204, 0.40) 69.55%)",
              },
              "& .MuiTypography-root": {
                color: theme.palette.primary.main,
                fontWeight: 700,
              },
            },
            "& .MuiBox-root": {
              width: "36px",
              height: "36px",
            },
          },
        },
        subCategoryFilterBar: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
          gap: theme.spacing(2),
          "& .MuiToggleButton-root.MuiToggleButtonGroup-grouped": {
            borderRadius: "32px",
            width: "fit-content",
            "& .MuiSvgIcon-root": {
              display: "flex",
              margin: 0,
            },
          },
        },
        venueSelector: {
          position: "absolute",
          left: "50%",
          bottom: "12%",
          transform: "translate(-50%, -50%)",
        },
        pageCard: {
          "&:after": {
            content: "''",
            pointerEvents: "none",
            display: "inline-block",
            position: "absolute",
            zIndex: 1,
            left: 0,
            right: 0,
            bottom: theme.spacing(13),
            minHeight: "180px",
            background: "transparent",
          },
        },
        motionDivStyle: {
          display: "flex",
          flexDirection: "column",
          height: "100%",
          gap: theme.spacing(3),
        },
      },
    },
    LuxuryPage: {
      styleOverrides: {
        pageCard: {
          padding: 0,
        },
        pageCardContent: {
          display: "flex",
          flexDirection: "column",
          padding: theme.spacing(5.5, 0, 5.5, 0),
          backgroundColor: "#D9D8DC",
          "&:last-of-type": {
            paddingBottom: theme.spacing(5.5),
          },
        },
        motionDivStyle: {
          display: "flex",
          height: "100%",
        },
        emptyDataWrapper: {
          height: "100%",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        swiperWrapper: {
          left: 0,
          width: "100%",
          height: "900px",
          overflow: "hidden",
          marginTop: "50px",
          "& .swiper": {
            maxWidth: "697px",
            height: "852px",
            alignItems: "flex-end",

            "& .swiper-wrapper": {
              alignItems: "flex-end",
              transitionTimingFunction: "ease-in-out",
            },

            "& .swiper-slide": {
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "1rem",
              color: "common.white",
              fontWeight: 700,
              fontSize: "2rem",
              transition: "all 0.5s ease",
              height: "85% !important",
              boxShadow:
                "0px 28px 74px 0px rgba(0, 0, 0, 0.01), 0px 22px 68px 0px rgba(0, 0, 0, 0.02), 0px 16px 57px 0px rgba(0, 0, 0, 0.05), 0px 12px 42px 0px rgba(0, 0, 0, 0.08), 0px 8px 23px 0px rgba(0, 0, 0, 0.10)",
            },

            "& .swiper-slide-active": {
              height: "100%  !important",
            },
          },
        },
      },
    },
    LuxuryCard: {
      styleOverrides: {
        root: {
          width: "100%",
          height: "100%",
          borderRadius: "4px",
          position: "relative",
          boxShadow: "none",
          "&.with-logo:before": {
            content: "''",
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            height: "100%",
            opacity: 1,
            background:
              "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 20%, #000 100.08%)",
            maskImage: "linear-gradient(to top, #000 20%, transparent)",
            WebkitMaskImage: "linear-gradient(to top, #000 20%, transparent)",
          },
        },
        cardMedia: {
          height: "100%",
          width: "100%",
        },
        logo: {
          zIndex: 1,
          height: "100%",
          width: "50%",
          position: "absolute",
          top: "80%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundSize: "contain",
        },
      },
    },
    LuxuryDetailPage: {
      styleOverrides: {
        pageCard: {
          padding: 0,
        },
        pageCardContent: {
          padding: 0,
          "&:last-of-type": {
            paddingBottom: 0,
          },
        },
        contentWrapper: {
          height: "100%",
          display: "flex",
          gap: theme.spacing(3),
        },
        gallaryWrapper: {
          minWidth: "232px",
          maxWidth: "232px",
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(3),
        },
        cardMediaStyle: {
          aspectRatio: "1",
        },
        mainBox: {
          position: "relative",
          width: "100%",
          height: "100%",
          backgroundColor: theme.palette.background.paper,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          "&:before": {
            content: "''",
            position: "absolute",
            bottom: "-1px",
            left: 0,
            width: "100%",
            height: "100%",
            opacity: 1,
            background:
              "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 55.08%, #000 100.08%)",
            maskImage: "linear-gradient(to top, #000 20%, transparent)",
            WebkitMaskImage: "linear-gradient(to top, #000 20%, transparent)",
          },
        },
        button: {
          minWidth: 188,
          height: "80px",
        },
        buttonContainer: {
          position: "absolute",
          right: 64,
          bottom: 40,
          paddingTop: 0,
          margin: 0,
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(4),
          alignItems: "end",
        },
        logoWrapper: {
          position: "absolute",
          left: 40,
          bottom: 40,
          "& img": {
            width: 300,
            height: "auto",
          },
        },
        qrCodeContainer: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1),
          "& .MuiPaper-root": {
            border: 0,
          },
        },
        qrCode: {
          backgroundColor: theme.palette.background.paper,
          "& .AppQRCode-content": {
            height: "100%",
            width: "100%",
            padding: 0,
            "&:last-of-type": {
              paddingBottom: 0,
            },
            "& .AppQRCode-qrcode": {
              border: 0,
            },
          },
        },
        qrCodeCaptionContainer: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        },
        qrcodePrimaryText: {
          fontSize: "1rem",
          lineHeight: "1.2",
          fontWeight: 700,
          color: "#FFF",
          textAlign: "center",
        },
        qrcodeSecondaryText: {
          lineHeight: "1.2",
          fontSize: "1rem",
          color: "#FFF",
          textAlign: "center",
          fontWeight: 500,
        },
        emptyDataWrapper: {
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
      },
    },
    MyLocationButton: {
      styleOverrides: {
        root: {
          width: "80px",
          height: "80px",
          padding: theme.spacing(2.25),
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "24px",
          boxShadow:
            "2px 2px 6px rgba(0, 0, 0, 0.07),10px 12px 10px rgba(0, 0, 0, 0.04), 20px 22px 12px rgba(0, 0, 0, 0.02)",
        },
        icon: {
          width: "44px",
          height: "44px",
          fill: theme.palette.text.secondary,
        },
      },
    },
    HomePage: {
      styleOverrides: {
        actionContainer: {
          width: "100%",
          marginTop: 0,
          display: "flex",
          justifyContent: "center",
          height: "100%",
          "&:before": {
            animation: "none",
            display: "none",
          },
          "&:after": {
            animation: "none",
            display: "none",
          },
        },
        actionButton: {
          flexDirection: "column",
          padding: 0,
        },
        touchToStartText: {
          textTransform: "uppercase",
        },
        touchToStartIcon: {
          width: 88,
          height: 88,
        },
        screensaverContainer: {
          position: "absolute",
          width: "561px",
          height: "1000px",
          top: "40px",
          left: "40px",
          "& .AdMediaCarousel-root": {
            inset: 0,
            width: "100%",
            height: "100%",
            overflow: "hidden",
            borderRadius: "20px",
            pointerEvents: "none",
            "& .splide__slide, & video, & img": {
              width: "100%",
              height: "100%",
              objectFit: "cover",
            },
          },
        },
      },
    },
    HomeWithScreenSaverPage: {
      styleOverrides: {
        pageCard: {
          display: "flex",
          gap: theme.spacing(8),
          background:
            "url(https://s3.venue.in.th/bg_kioskh_1_8e9e4008ab.png) no-repeat -40px -40px/136%,linear-gradient(0deg, #F4F3F3, #F4F3F3),linear-gradient(0deg, #FFFFFF, #FFFFFF),linear-gradient(180deg, #F8F8FF 5.51%, rgba(248, 248, 255, 0) 41.3%)",
          overflow: "hidden",
        },
        actionButton: {
          width: "100%",
          height: "100%",
          display: "block",
          "&:before": {
            content: "''",
            position: "absolute",
            width: "100%",
            height: "50px",
            backgroundImage:
              "url(https://s3.venue.in.th/iconsiam_mobile_touch_to_navigate_flare_top_c2037dcae8.svg)",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            mixBlendMode: "screen",
            top: "-1px",
            pointerEvents: "none",
            left: 0,
          },
          "&:after": {
            content: "''",
            position: "absolute",
            width: "100%",
            height: "100%",
            backgroundImage:
              "url(https://s3.venue.in.th/iconsiam_mobile_touch_to_navigate_flare_41b77e49fb.svg)",
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            mixBlendMode: "screen",
            bottom: "-68px",
            pointerEvents: "none",
            left: 0,
          },
        },
        contentContainer: {
          marginLeft: "auto",
          width: "807px",
          height: "100%",
          background:
            "linear-gradient(359.78deg, rgba(200, 175, 85, 0.85) 33.36%, rgba(255, 255, 255, 0.7) 99.81%), url(https://s3.venue.in.th/welcome_panel_kiosk_h_1_9f8e8fc388.png) no-repeat center / cover",
          opacity: 0.9,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: theme.spacing(15),
          borderRadius: "20px",
        },
        welcomeContainer: {
          background:
            "linear-gradient(270deg, rgba(238, 231, 204, 0) 2.25%, #EEE7CC 52.88%, rgba(238, 231, 204, 0) 100%) padding-box, linear-gradient(270deg, rgba(238, 231, 204, 0) 20%, #AC8700 52.88%, rgba(238, 231, 204, 0) 80%) border-box",
          border: "2px solid transparent",
          width: "582px",
          height: "144px",
          padding: 0,
        },
        touchToStartIcon: {
          width: 68,
          height: 68,
        },
        touchToStartText: {
          fontSize: "1.875rem",
          fontWeight: 500,
          textTransform: "uppercase",
        },
      },
    },
    HomeWithInfosPage: {
      styleOverrides: {
        actionContainer: {
          width: "100%",
          marginTop: 0,
          display: "flex",
          justifyContent: "center",
          height: "100%",
          "&:after, :before": {
            display: "none",
          },
        },
        actionButton: {
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
          padding: 0,
          "&:before": {
            content: "''",
            position: "absolute",
            width: "100%",
            height: "100px",
            backgroundImage:
              "url(https://s3.venue.in.th/iconsiam_mobile_touch_to_navigate_flare_top_c2037dcae8.svg)",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            mixBlendMode: "screen",
            top: "0px",
            pointerEvents: "none",
          },
          "&:after": {
            content: "''",
            position: "absolute",
            width: "100%",
            height: "100%",
            backgroundImage:
              "url(https://s3.venue.in.th/iconsiam_mobile_touch_to_navigate_flare_41b77e49fb.svg)",
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            mixBlendMode: "screen",
            bottom: "-58px",
            pointerEvents: "none",
          },
        },
        contentContainer: {
          height: "100%",
          width: "100%",
          background:
            "linear-gradient(359.78deg, #C8AF55 33.36%, #FFFFFF 99.81%)",
          opacity: 0.9,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: theme.spacing(15),
        },
        welcomeContainer: {
          background:
            "linear-gradient(270deg, rgba(238, 231, 204, 0) 2.25%, #EEE7CC 52.88%, rgba(238, 231, 204, 0) 100%) padding-box, linear-gradient(270deg, rgba(238, 231, 204, 0) 20%, #AC8700 52.88%, rgba(238, 231, 204, 0) 80%) border-box",
          border: "2px solid transparent",
          width: 747,
          height: 124,
          padding: 0,
        },
        touchToStartText: {
          fontSize: "2.5rem",
          fontWeight: 500,
          textTransform: "uppercase",
        },
        touchToStartIcon: {
          width: 88,
          height: 88,
        },
        pageCard: {
          background: "transparent",
          overflow: "hidden",
        },
        classicWelcomeContainer: {
          background:
            "linear-gradient(270deg, rgba(238, 231, 204, 0) 2.25%, #EEE7CC 52.88%, rgba(238, 231, 204, 0) 100%) padding-box, linear-gradient(270deg, rgba(238, 231, 204, 0) 20%, #AC8700 52.88%, rgba(238, 231, 204, 0) 80%) border-box",
          border: "2px solid transparent",
          width: 747,
          height: 185,
          padding: 0,
        },
        classicActionButton: {
          flexDirection: "column",
          width: "100%",
          height: "100%",
          display: "block",
          padding: 0,
          "&:before": {
            content: "''",
            position: "absolute",
            width: "100%",
            height: "50px",
            backgroundImage:
              "url(https://s3.venue.in.th/iconsiam_mobile_touch_to_navigate_flare_top_c2037dcae8.svg)",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            mixBlendMode: "screen",
            top: 0,
            pointerEvents: "none",
            left: 0,
          },
          "&:after": {
            content: "''",
            position: "absolute",
            width: "100%",
            height: "100%",
            backgroundImage:
              "url(https://s3.venue.in.th/iconsiam_mobile_touch_to_navigate_flare_41b77e49fb.svg)",
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            mixBlendMode: "screen",
            bottom: "-85px",
            pointerEvents: "none",
            left: 0,
          },
        },
        classicTouchToStartText: {
          fontSize: "2.5rem",
          fontWeight: 500,
          textTransform: "uppercase",
        },
      },
    },
    HomeWithScreenSaverInfosPage: {
      styleOverrides: {
        actionContainer: {
          width: "100%",
          marginTop: 0,
          display: "flex",
          justifyContent: "center",
          height: "100%",
          "&:after, :before": {
            display: "none",
          },
        },
        actionButton: {
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
          padding: 0,
          "&:before": {
            content: "''",
            position: "absolute",
            width: "100%",
            height: "100px",
            backgroundImage:
              "url(https://s3.venue.in.th/iconsiam_mobile_touch_to_navigate_flare_top_c2037dcae8.svg)",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            mixBlendMode: "screen",
            top: "0px",
            pointerEvents: "none",
          },
          "&:after": {
            content: "''",
            position: "absolute",
            width: "100%",
            height: "100%",
            backgroundImage:
              "url(https://s3.venue.in.th/iconsiam_mobile_touch_to_navigate_flare_41b77e49fb.svg)",
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            mixBlendMode: "screen",
            bottom: "-58px",
            pointerEvents: "none",
          },
        },
        contentContainer: {
          width: "100%",
          height: "100%",
        },
        infoPanel: {
          marginLeft: "auto",
          width: "807px",
          height: "100%",
          background:
            "linear-gradient(359.78deg, rgba(200, 175, 85, 0.85) 33.36%, rgba(255, 255, 255, 0.7) 99.81%), url(https://s3.venue.in.th/welcome_panel_kiosk_h_1_9f8e8fc388.png) no-repeat center / cover",
          opacity: 0.9,
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
          paddingTop: "141px",
          gap: theme.spacing(17.5),
          borderRadius: "20px",
        },
        welcomeContainer: {
          background:
            "linear-gradient(270deg, rgba(238, 231, 204, 0) 2.25%, #EEE7CC 52.88%, rgba(238, 231, 204, 0) 100%)",
          width: 747,
          height: 124,
          padding: 0,
        },
        touchToStartText: {
          fontSize: "2.5rem",
          fontWeight: 500,
          textTransform: "uppercase",
          color: theme.palette.primary.main,
        },
        touchToStartIcon: {
          width: 88,
          height: 88,
        },
        pageCard: {
          display: "flex",
          gap: theme.spacing(8),
          background:
            "url(https://s3.venue.in.th/bg_kioskh_1_8e9e4008ab.png) no-repeat -40px -40px/136%,linear-gradient(0deg, #F4F3F3, #F4F3F3),linear-gradient(0deg, #FFFFFF, #FFFFFF),linear-gradient(180deg, #F8F8FF 5.51%, rgba(248, 248, 255, 0) 41.3%)",
          overflow: "hidden",
        },
        classicWelcomeContainer: {
          background:
            "linear-gradient(270deg, rgba(238, 231, 204, 0) 2.25%, #EEE7CC 52.88%, rgba(238, 231, 204, 0) 100%) padding-box, linear-gradient(270deg, rgba(238, 231, 204, 0) 20%, #AC8700 52.88%, rgba(238, 231, 204, 0) 80%) border-box",
          border: "2px solid transparent",
          width: 747,
          height: 185,
          padding: 0,
        },
        classicActionButton: {
          flexDirection: "column",
          width: "100%",
          height: "100%",
          display: "block",
          padding: 0,
          "&:before": {
            content: "''",
            position: "absolute",
            width: "100%",
            height: "50px",
            backgroundImage:
              "url(https://s3.venue.in.th/iconsiam_mobile_touch_to_navigate_flare_top_c2037dcae8.svg)",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            mixBlendMode: "screen",
            top: 0,
            pointerEvents: "none",
            left: 0,
          },
          "&:after": {
            content: "''",
            position: "absolute",
            width: "100%",
            height: "100%",
            backgroundImage:
              "url(https://s3.venue.in.th/iconsiam_mobile_touch_to_navigate_flare_41b77e49fb.svg)",
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            mixBlendMode: "screen",
            bottom: "-85px",
            pointerEvents: "none",
            left: 0,
          },
        },
        classicTouchToStartText: {
          fontSize: "2.5rem",
          fontWeight: 500,
          textTransform: "uppercase",
        },
      },
    },
    PlaceDetailPage: {
      styleOverrides: {
        pageCardSideBar: {
          marginTop: theme.spacing(5),
          height: "calc(100% - 40px)", // 40px is reference from AppContentWithAside->asideWrapper marginTop
          borderRadius: "32px",
          boxShadow:
            "184px 236px 84px 0px rgba(0, 0, 0, 0.00), 118px 151px 77px 0px rgba(0, 0, 0, 0.01), 66px 85px 65px 0px rgba(0, 0, 0, 0.03), 29px 38px 48px 0px rgba(0, 0, 0, 0.05), 7px 9px 26px 0px rgba(0, 0, 0, 0.06)",
        },
        floorSelectionWrapper: {
          position: "absolute",
          top: "50%",
          right: "40px",
          transform: "translate(0, -50%)",
          opacity: 0,
          animation: "fadeIn 0.3s ease-in-out 0.5s forwards",
        },
      },
    },
    PlaceDetailSideBar: {
      defaultProps: {
        galleryCarouselOption: {
          arrowPath: "M31 19.4983L10 3L20.4966 19.4983L10 36L31 19.4983Z",
        },
      },
      styleOverrides: {
        root: {
          height: "100%",
        },
        headerContainer: {
          paddingTop: 0,
          height: "130px",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: 0,
        },
        chipContainer: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: theme.spacing(1),
        },
        contentContainer: {
          padding: theme.spacing(4),
          gap: theme.spacing(3),
          display: "flex",
          flexDirection: "column",
          height: "100%",
        },
        descriptionContainer: {
          height: "80px",
          lineHeight: "1.2",
          marginBottom: theme.spacing(1),
          marginTop: 0,
          "&:before": {
            display: "none",
          },
        },
        descriptionText: {
          maxHeight: "100%",
          fontSize: "1rem",
          lineHeight: 1.3,
          marginBottom: 0,
          color: theme.palette.text.secondary,
          scrollbarWidth: "auto",
          paddingBottom: 0,
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            background: theme.palette.text.secondary,
            borderRadius: "9999px",
          },
        },
        titleText: {
          fontSize: "2rem",
          color: theme.palette.text.primary,
          lineHeight: 1.1,
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
          fontWeight: 700,
          paddingRight: theme.spacing(10),
        },
        avatarContainer: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1.5),
          width: "140px",
        },
        avatarRoot: {
          background: theme.palette.background.paper,
          color: theme.palette.text.secondary,
          border: `1px solid ${theme.palette.divider}`,
          margin: 0,
          height: 140,
          width: 140,
          borderRadius: "12px",
          "& .MuiSvgIcon-root": {
            width: 60,
            height: 60,
          },
        },
        sidebarContent: {
          background: theme.palette.background.paper,
        },
        infoListContainer: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          gap: theme.spacing(1.5),
          width: "200px",
        },
        infoListItem: {
          display: "flex",
          gap: theme.spacing(1),
          "& path": {
            fill: "",
          },
          "&.is-coming-soon": {
            "& > *,& .VuiDescriptionList-root > *": {
              color: theme.palette.error.main,
            },
          },
        },
        infoLabel: {
          alignItems: "start",
          fontWeight: 400,
          color: theme.palette.text.secondary,
          "& .VuiDescriptionList-labelText": {
            textTransform: "uppercase",
            fontSize: "0.75rem",
            fontWeight: 700,
            lineHeight: 1.6,
          },
        },
        openingLabel: {},
        qrCodeContainer: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1),
          padding: 0,
          "&:not(.has-gallery)": {
            marginTop: "unset",
          },
        },
        qrCode: {
          minWidth: "100px",
          minHeight: "100px",
          width: "100px",
          height: "100px",
          padding: 0,
          "& .AppQRCode-content": {
            height: "100%",
            width: "100%",
          },
        },
        qrCodeCaptionContainer: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        },
        qrcodePrimaryText: {
          fontSize: "1rem",
          lineHeight: "1.2",
          fontWeight: 700,
          color: theme.palette.text.primary,
          textAlign: "center",
        },
        qrcodeSecondaryText: {
          lineHeight: "1.2",
          fontSize: "1rem",
          color: theme.palette.text.primary,
          textAlign: "center",
          fontWeight: 500,
        },
        closeButton: {
          position: "absolute",
          top: "57px",
          right: "16px",
          padding: 0,
          width: "82px",
          height: "82px",
          borderRadius: "50%",
          backgroundColor: "#F8F8FF",
          border: `1px solid ${theme.palette.divider}`,
          "& .MuiSvgIcon-root": {
            width: "20px",
            height: "20px",
            color: theme.palette.text.primary,
          },
          "&:hover": {
            backgroundColor: "#F8F8FF",
          },
        },
        infoContainer: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(6),
          margin: 0,
        },
        actionContainer: {
          marginTop: "auto",
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1.5),
        },
        mainActionButtons: {},
        additionalActionButtons: {
          display: "flex",
          gap: theme.spacing(1.5),
        },
        actionButton: {
          flex: "1 1 100%",
          height: "80px",
          width: "100%",
          fontSize: "1.156rem",
          borderRadius: "20px",
        },
        galleryCarouselWrapper: {
          marginTop: 0,
          "&:before": {
            content: "''",
            position: "absolute",
            width: "65px",
            height: "220px",
            background:
              "linear-gradient(-90deg, rgba(256, 256, 256, 1) 0%, rgba(256, 256, 256, 0) 100%)",
            right: "-4px",
            zIndex: 1,
          },
          '[dir="rtl"] &:before': {
            background:
              "linear-gradient(90deg, rgba(256, 256, 256, 1) 0%, rgba(256, 256, 256, 0) 100%)",
          },
        },
        galleryCarousel: {
          position: "absolute",
          width: "100%",
          "& .splide__track": {
            margin: 0,
            padding: 0,
          },
          "& .splide__arrow": {
            margin: theme.spacing(0),
            width: "24px",
            height: "24px",
            borderRadius: "9999px",
            background: theme.palette.background.default,
            opacity: 1,
            transition: "opacity 0.15s ease-in-out",
            "&:disabled": {
              opacity: 0,
              pointerEvents: "none",
            },
          },
        },
        galleryCarouselItem: {
          width: "330px !important",
          borderRadius: "4px",
        },
        galleryImage: {
          aspectRatio: "3 / 2",
          borderRadius: "4px",
        },
        newShopChip: {
          display: "flex",
          height: "38px",
          "& .MuiChip-label": {
            fontSize: "1.125rem",
            fontWeight: 400,
          },
          marginBottom: theme.spacing(1.125),
          marginLeft: "unset",
        },
        comingSoonChip: {
          display: "flex",
          height: "38px",
          "& .MuiChip-label": {
            fontSize: "1.125rem",
            fontWeight: 400,
          },
          marginBottom: theme.spacing(1.125),
          marginLeft: "unset",
        },
        vatRefundChip: {
          display: "flex",
          width: "145px",
          height: "38px",
          "& .MuiChip-label": {
            fontSize: "1.125rem",
            fontWeight: 400,
          },
          marginBottom: theme.spacing(1.125),
          marginLeft: "unset",
        },
        galleryCarouselModal: {
          "&.PlaceDetailSideBar-galleryCarouselModal": {
            "& .AppImageCarouselModal-image": {
              width: "880px",
              height: "587px",
            },
            "& .AppImageCarouselModal-carouselItem": {
              maxWidth: "914px",
            },
          },
        },
      },
    },
    AppDirectionOverview: {
      styleOverrides: {
        pageCardSideBar: {
          marginTop: theme.spacing(5),
          height: "calc(100% - 40px)", // 40px is reference from AppContentWithAside->asideWrapper marginTop
          borderRadius: "32px",
          boxShadow:
            "184px 236px 84px 0px rgba(0, 0, 0, 0.00), 118px 151px 77px 0px rgba(0, 0, 0, 0.01), 66px 85px 65px 0px rgba(0, 0, 0, 0.03), 29px 38px 48px 0px rgba(0, 0, 0, 0.05), 7px 9px 26px 0px rgba(0, 0, 0, 0.06)",
        },
        sidebarContent: {
          background: theme.palette.background.paper,
        },
        root: {
          height: "100%",
          padding: theme.spacing(4, 4, 1, 4),
        },
        contentContainer: {
          display: "flex",
          flexDirection: "column",
          width: "100%",
          padding: 0,
        },
        headerContainer: {
          height: "155px",
          display: "grid",
          gridTemplateAreas: `
          "logo title"
          "logo title"
          "venueLogo venueLogo"
        `,
          gridTemplateRows: "repeat(3, max-content)",
          gridTemplateColumns: "repeat(2, max-content)",
          gridGap: theme.spacing(3, 1.5),
          alignSelf: "start",
        },
        logoContainer: {
          gridArea: "logo",
        },
        titleText: {
          gridArea: "title",
          fontSize: "1.75rem",
          color: theme.palette.text.primary,
          lineHeight: 1.3,
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
          fontWeight: 700,
          width: "314px",
        },
        venueLogo: {
          gridArea: "venueLogo",
          width: "108px",
        },
        travelInfoContainer: {
          height: "236px",
          display: "grid",
          gridTemplateAreas: `
          "routeInfo qr"
          "routeInfo qr"
          "divider divider"
          "description description"
        `,
          gridTemplateRows: "repeat(4, max-content)",
          gridTemplateColumns: "repeat(2, 1fr)",
          marginTop: theme.spacing(3),
        },
        routeDetailContainer: {
          gridArea: "routeInfo",
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1.5),
          alignItems: "flex-start",
          marginRight: theme.spacing(1.25),
          marginTop: theme.spacing(0),
          padding: 0,
        },
        durationContainer: {
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: theme.spacing(1),
        },
        qrCodeContainer: {
          gridArea: "qr",
          justifySelf: "end",
          flexDirection: "column",
          marginTop: 0,
          padding: 0,
          gap: theme.spacing(1),
        },
        qrCode: {
          padding: 0,
          width: "120px",
          height: "120px",
          "& .AppQRCode-content": {
            height: "100%",
            width: "100%",
          },
        },
        qrCodeCaptionContainer: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        },
        qrcodePrimaryText: {
          fontSize: "1rem",
          lineHeight: "1.2",
          fontWeight: 700,
          color: theme.palette.text.primary,
          textAlign: "center",
        },
        qrcodeSecondaryText: {
          fontSize: "1rem",
          lineHeight: "1.2",
          fontWeight: 400,
          color: theme.palette.text.primary,
          textAlign: "center",
        },
        divider: {
          gridArea: "divider",
          borderBottomWidth: "1px",
          margin: theme.spacing(1.5, 0, 3),
          borderImage:
            "linear-gradient(270deg, #EEE7CC 1.77%, #AC8700 51.45%, #EEE7CC 72.16%) 1",
        },
        routeDescription: {
          gridArea: "description",
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(1.75),
          alignItems: "center",
          fontSize: "1.25px",
          color: theme.palette.text.secondary,
          paddingBottom: 0,
        },
        separator: {
          width: "32px",
          height: "32px",
        },
        highlightText: {
          fontWeight: 700,
          fontSize: "1rem",
          color: theme.palette.text.primary,
          textOverflow: "ellipsis",
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: 1,
          WebkitBoxOrient: "vertical",
          maxWidth: "calc(65% - 74px)", // 74px = width of "from" text + ">" arrow
        },
        primaryText: {
          fontSize: "3rem",
          fontWeight: 700,
          color: theme.palette.text.primary,
          lineHeight: 1.2,
        },
        secondaryText: {
          fontSize: "1.5rem",
          fontWeight: 400,
          color: theme.palette.text.secondary,
          lineHeight: 1.2,
        },
        stepContainer: {
          position: "relative",
          marginTop: theme.spacing(3),
          height: "401px",
          "&:before": {
            content: "''",
            position: "absolute",
            width: "calc(100% - 8px)",
            height: "16px",
            background:
              "linear-gradient(180deg, rgba(256, 256, 256, 1) 0%, rgba(256, 256, 256, 0) 100%)",
            top: "-1px",
            zIndex: 1,
          },
          "&:after": {
            content: "''",
            position: "absolute",
            width: "calc(100% - 8px)",
            height: "16px",
            background:
              "linear-gradient(0, rgba(256, 256, 256, 1) 0%, rgba(256, 256, 256, 0) 100%)",
            bottom: "-1px",
            zIndex: 1,
          },
        },
        stepListAvatarContainer: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minWidth: "40px",
          marginRight: theme.spacing(1.25),
        },
        stepListContainer: {
          width: "100%",
          height: "100%",
          maxWidth: "auto",
          padding: theme.spacing(0, 1, 3.5, 0),
          background: "transparent",
          maxHeight: "unset",
          marginTop: 0,
          "&::-webkit-scrollbar": {
            width: "8px",
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#8C8A94",
            borderRadius: "9999px",
          },
        },
        stepListItem: {
          padding: 0,
          "& .step": {
            backgroundColor: "#C9C5C6",
          },
        },
        stepListItemText: {
          "& .MuiListItemText-primary": {
            color: theme.palette.text.primary,
            fontSize: "1rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            whiteSpace: "normal",
            lineHeight: 1.4,
            fontWeight: 400,
          },
          "& .MuiListItemText-secondary": {
            color: theme.palette.text.primary,
            fontSize: "1rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            whiteSpace: "normal",
            lineHeight: "normal",
            fontWeight: 400,
          },
        },
        connector: {
          display: "flex",
          marginLeft: theme.spacing(2.25),
          "& .MuiStepConnector-line": {
            background: "transparent",
            borderLeft: "4px dotted #C9C5C6",
            width: "4px",
            minHeight: "86px",
            height: "calc(100% + 40px)",
            margin: theme.spacing(-3.75, 0),
          },
          "&:last-of-type": {
            marginBottom: theme.spacing(1.75),
          },
        },
        logoImage: {
          width: "60%",
          objectFit: "contain",
          maxHeight: 34,
        },
        listItemIcon: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: theme.palette.background.default,
          width: "80px",
          height: "40px",
          borderRadius: "16px",
          marginRight: theme.spacing(1),
        },
        actionContainer: {
          marginTop: theme.spacing(3),
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(1),
          width: "100%",
        },
        avoidStepButton: {
          width: "auto",
          height: "52px",
          padding: theme.spacing(1.5, 2, 1.5, 2.5),
          borderRadius: "9999px",
          border: `1px solid ${theme.palette.divider}`,
          margin: theme.spacing(1.5, 0, 0, -1.5),
          "& .MuiTypography-root": {
            fontSize: "1.25rem",
            fontWeight: 400,
            textTransform: "capitalize",
            color: theme.palette.text.secondary,
          },
          "& .MuiFormControlLabel-label": {
            fontSize: "1.25rem",
            marginLeft: "unset",
          },
        },
        startButton: {
          height: "80px",
          flex: "1 1 100%",
          fontSize: "1.25rem",
        },
        ordinalSelectMenu: {
          position: "absolute",
          top: "50%",
          right: "40px",
          transform: "translate(0, -50%)",
          bottom: "unset",
        },
      },
    },
    AppStepByStep: {
      styleOverrides: {
        pageCardSideBar: {
          marginTop: theme.spacing(5),
          height: "calc(100% - 40px)", // 40px is reference from AppContentWithAside->asideWrapper marginTop
          borderRadius: "32px",
          boxShadow:
            "184px 236px 84px 0px rgba(0, 0, 0, 0.00), 118px 151px 77px 0px rgba(0, 0, 0, 0.01), 66px 85px 65px 0px rgba(0, 0, 0, 0.03), 29px 38px 48px 0px rgba(0, 0, 0, 0.05), 7px 9px 26px 0px rgba(0, 0, 0, 0.06)",
        },
        sidebarContent: {
          background: theme.palette.background.paper,
        },
        root: {
          height: "100%",
          padding: theme.spacing(4, 4, 1, 4),
        },
        contentContainer: {
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
          gap: theme.spacing(4),
          padding: 0,
        },
        headerContainer: {
          height: "164px",
          display: "grid",
          gridTemplateAreas: `
          "logo title"
          "logo title"
          "venueLogo venueLogo"
        `,
          gridTemplateRows: "repeat(3, max-content)",
          gridTemplateColumns: "repeat(2, max-content)",
          gridGap: theme.spacing(3, 1.5),
          alignSelf: "start",
        },
        logoContainer: {
          gridArea: "logo",
        },
        titleText: {
          gridArea: "title",
          fontSize: "1.75rem",
          color: theme.palette.text.primary,
          lineHeight: 1.3,
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
          fontWeight: 700,
          width: "314px",
        },
        venueLogo: {
          gridArea: "venueLogo",
          width: "108px",
        },
        separator: {
          width: "32px",
          height: "32px",
        },
        stepContainer: {
          height: "100%",
          "&:before": {
            content: "''",
            position: "absolute",
            width: "495px",
            height: "48px",
            background:
              "linear-gradient(0, rgba(256, 256, 256, 1) 0%, rgba(256, 256, 256, 0) 100%)",
            bottom: "138px",
            zIndex: 1,
          },
        },
        stepListAvatarContainer: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minWidth: "40px",
          marginRight: theme.spacing(1.25),
        },
        stepListContainer: {
          height: "100%",
          maxWidth: "auto",
          padding: theme.spacing(0, 1, 3.5, 0),
          "&::-webkit-scrollbar": {
            width: "8px",
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#8C8A94",
          },
        },
        stepListItem: {
          padding: 0,
          "& .step": {
            backgroundColor: "#C9C5C6",
          },
        },
        stepListItemText: {
          "& .MuiListItemText-primary": {
            color: theme.palette.text.primary,
            fontSize: "1rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            whiteSpace: "normal",
            lineHeight: 1.4,
            fontWeight: 400,
          },
          "& .MuiListItemText-secondary": {
            color: theme.palette.text.primary,
            fontSize: "1rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            whiteSpace: "normal",
            lineHeight: "normal",
            fontWeight: 400,
          },
        },
        connector: {
          display: "flex",
          marginLeft: theme.spacing(2.25),
          "& .MuiStepConnector-line": {
            background: "transparent",
            borderLeft: "4px dotted #C9C5C6",
            width: "4px",
            minHeight: "86px",
            height: "calc(100% + 40px)",
            margin: theme.spacing(-3.75, 0),
          },
          "&:last-of-type": {
            marginBottom: theme.spacing(1.75),
          },
        },
        logoImage: {
          width: "60%",
          objectFit: "contain",
          maxHeight: 34,
        },
        listItemIcon: {
          justifyContent: "center",
          alignItems: "center",
          background: theme.palette.background.default,
          width: "80px",
          height: "40px",
          borderRadius: "16px",
          marginRight: theme.spacing(1),
        },
        actionContainer: {
          marginTop: theme.spacing(3),
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(1),
          width: "100%",
        },
        ordinalSelectMenu: {
          position: "absolute",
          top: "50%",
          right: "40px",
          transform: "translate(0, -50%)",
        },
        stepProgressBarContainer: {
          position: "relative",
          "&:after": {
            content: "''",
            display: "inline-block",
            height: "16px",
            background:
              "linear-gradient(180deg, rgba(255, 255, 255, 0.00) 10%, #fff 90%)",
            zIndex: 2,
            position: "absolute",
            bottom: theme.spacing(-0.25),
            left: 0,
            right: 0,
            width: "calc(100% - 8px)",
          },
          "&:before": {
            content: "''",
            display: "inline-block",
            height: "16px",
            background:
              "linear-gradient(0, rgba(255, 255, 255, 0.00) 10%, #fff 90%)",
            zIndex: 2,
            position: "absolute",
            top: theme.spacing(-0.25),
            left: 0,
            right: 0,
            width: "calc(100% - 8px)",
          },
        },
        stepProgressBar: {
          height: "604px",
          margin: "auto 0",
          padding: 0,
        },
        playerButton: {
          fontSize: "1.25rem",
          flex: 1,
          fontWeight: 700,
          padding: theme.spacing(1.5, 1),
          height: "80px",
          "& .MuiSvgIcon-root": {
            width: "24px",
            height: "24px",
          },
        },
        closeButton: {
          position: "absolute",
          top: "57px",
          right: "16px",
          padding: 0,
          width: "82px",
          height: "82px",
          borderRadius: "50%",
          backgroundColor: "#F8F8FF",
          border: `1px solid ${theme.palette.divider}`,
          "& .MuiSvgIcon-root": {
            width: "20px",
            height: "20px",
            color: theme.palette.text.primary,
          },
          "&:hover": {
            backgroundColor: "#F8F8FF",
          },
        },
      },
    },
    VerticalStepProgressBar: {
      styleOverrides: {
        wrapper: {},
        stepperContainer: {
          scrollbarWidth: "auto",
          scrollbarHeight: "auto",
          "&.MuiStepper-root": {
            padding: theme.spacing(2, 4),
          },
          "&::-webkit-scrollbar": {
            display: "block",
            width: "8px",
          },
          "&-ms-overflow-style:": {
            display: "block",
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#8C8A94",
            borderRadius: "40px",
          },
        },
        stepper: {
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          zIndex: 1,
          "& .MuiButtonBase-root": {
            display: "flex",
          },
          "& .MuiStepLabel-root": {
            padding: 0,
          },
          "& .MuiStepLabel-label": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            whiteSpace: "normal",
            position: "relative",
            bottom: "unset",
            padding: 0,
            fontSize: "1rem",
            lineHeight: 1.2,
          },
          "& .MuiStepLabel-iconContainer": {
            paddingRight: theme.spacing(1.25),
            "&:last-child": {
              paddingRight: 0,
            },
          },
          "& .step": {
            backgroundColor: "#C9C5C6",
            width: "40px",
            height: "40px",
            fontSize: "1.25rem",
            "& svg": {
              width: "20px",
              height: "20px",
            },
          },
          "&.originStep": {
            visibility: "visible",
            "& .MuiStepLabel-label": {
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: theme.spacing(1),
            },
          },
          "&.destinationStep": {
            "& .MuiStepLabel-label": {
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: theme.spacing(1),
            },
            "& .MuiBox-root": {
              width: "40px",
              height: "40px",
            },
            "& .MuiSvgIcon-root": {
              visibility: "visible",
              width: "40px",
              height: "40px",
              background: theme.palette.common.white,
            },
          },
          "& .Mui-active, & .Mui-completed": {
            "& .step:not(.originStep,.StepByStepIcon-destination)": {
              backgroundColor: theme.palette.primary.main,
            },
          },
        },
        connector: {
          marginLeft: theme.spacing(2.25),
          "& .MuiStepConnector-line": {
            background: "transparent",
            borderLeft: "4px dotted #C9C5C6",
            width: "4px",
            minHeight: "86px",
            height: "calc(100% + 40px)",
            margin: theme.spacing(-2.5, 0),
          },
          "&.Mui-active": {
            "& .MuiStepConnector-line": {
              background: "transparent",
              borderLeft: `4px solid ${theme.palette.primary.main}`,
            },
          },
          "&.Mui-completed": {
            "& .MuiStepConnector-line": {
              background: "transparent",
              borderLeft: `4px solid ${theme.palette.primary.main}`,
            },
          },
        },
      },
    },
    DirectionStep: {
      styleOverrides: {
        highlightedText: {
          color: theme.palette.text.primary,
        },
      },
    },
    AppNavigationStep: {
      styleOverrides: {
        destinationIcon: {
          width: "40px",
          height: "40px",
        },
        originIcon: {
          width: "40px",
          height: "40px",
        },
        locationAvatar: {
          width: "108px",
          height: "108px",
          borderRadius: "12px",
          background: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
          color: theme.palette.text.secondary,
          margin: 0,
          "& .MuiAvatar-img": {
            objectFit: "cover",
          },
        },
        venueLogo: {},
        cooldownProgress: {
          display: "block",
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          padding: theme.spacing(0, 1.5),
          "& .CoolDownProgress-linearProgress": {
            height: "10px",
            borderBottomRightRadius: "32px",
            borderBottomLeftRadius: "32px",
          },
        },
      },
    },
    SkeletonDirectionOverviewSidebar: {
      styleOverrides: {
        root: {
          padding: theme.spacing(4),
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: theme.spacing(2),
          "&>*": {
            width: "100%",
          },
        },
        divider: {
          borderColor: "#E4E2E3",
          marginTop: theme.spacing(5),
          marginBottom: theme.spacing(2),
          width: "100%",
        },
        headerWrapper: {
          display: "flex",
          padding: 0,
          flexDirection: "row",
          gap: theme.spacing(3),
          alignItems: "start",
        },
        logoWrapper: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1.5),
        },
        venueAvatar: {
          height: "35px",
        },
        locationAvatar: {
          width: "108px",
          height: "108px",
        },
        locationText: {
          height: "40px",
          width: "250px",
        },
        durationText: {
          width: "165px",
          height: "50px",
        },
        distanceText: {
          width: "94px",
          height: "38px",
        },
        travelInfoText: {
          width: "320px",
          height: "38px",
        },
        contentWrapper: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          padding: 0,
        },
        durationWrapper: {
          height: "100%",
        },
        qrCodeContainer: {
          gridArea: "qr",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        },
        qrCode: {
          width: "118px",
          height: "118px",
        },
        qrcodeText: {
          width: "108px",
          height: "34px",
        },
        stepContainer: {
          marginTop: theme.spacing(5, 0),
        },
        stepListContainer: {
          width: "100%",
          height: "500px",
        },
        actionContainer: {
          marginTop: "auto",
        },
        startButton: {
          width: "100%",
          height: "80px",
        },
      },
    },
    SkeletonStepByStepSidebar: {
      styleOverrides: {
        root: {
          padding: theme.spacing(4),
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: theme.spacing(2),
          "&>*": {
            width: "100%",
          },
        },
        headerWrapper: {
          display: "flex",
          padding: 0,
          flexDirection: "row",
          gap: theme.spacing(3),
          alignItems: "start",
        },
        logoWrapper: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1.5),
        },
        locationAvatar: {
          width: "108px",
          height: "108px",
        },
        locationText: {
          width: "200px",
        },
        stepContainer: {
          marginTop: theme.spacing(5, 0),
        },
        stepListContainer: {
          width: "100%",
          height: "678px",
        },
        actionContainer: {
          marginTop: "auto",
        },
        startButton: {
          width: "100%",
          height: "80px",
        },
      },
    },
    AppSidebar: {
      styleOverrides: {
        closeButton: {
          position: "absolute",
          top: "-15px",
          right: "-16px",
          padding: 0,
          width: "82px",
          height: "82px",
          borderRadius: "50%",
          backgroundColor: "#F8F8FF",
          border: `1px solid ${theme.palette.divider}`,
          "& .MuiSvgIcon-root": {
            width: "20px",
            height: "20px",
            color: theme.palette.text.primary,
          },
          "&:hover": {
            backgroundColor: "#F8F8FF",
          },
        },
      },
    },
    VuiDescriptionList: {
      styleOverrides: {
        contentText: {
          color: theme.palette.text.primary,
          fontWeight: 700,
          fontSize: "1rem",
          lineHeight: 1.3,
          marginTop: "4px",
          WebkitLineClamp: 1,
        },
      },
    },
    OrdinalSelector: {
      defaultProps: {
        popoverProps: {
          slotProps: {
            backdrop: {
              sx: { background: "transparent" },
            },
          },
          anchorOrigin: {
            vertical: "center",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "center",
            horizontal: "right",
          },
        },
        popperProps: {
          // [@Doc](https://mui.com/material-ui/react-popper/#scroll-playground)
          modifiers: [
            {
              name: "preventOverflow",
              enabled: false,
            },
            {
              name: "offset",
              options: {
                offset: [0, -14],
              },
            },
          ],
        },
      },
      styleOverrides: {
        root: {
          "&:after": {
            pointerEvents: "none",
            position: "absolute",
            bottom: 0,
            opacity: 0,
            right: "65px",
            content: "''",
            background: theme.palette.background.paper,
            width: "0",
            height: "84px",
            transition: `all ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeInOut}, borderRadius ${theme.transitions.duration.standard}s ${theme.transitions.easing.easeInOut}`,
            clipPath:
              "path('M0 0.613281C0.000148435 12.4251 9.57494 21.9999 21.3867 22C28.9077 22 35.5943 17.6887 41.2393 12.7188C42.4301 11.67 43.6868 10.6948 45 9.7959V74.2031C43.687 73.3043 42.43 72.3298 41.2393 71.2812C35.5943 66.3113 28.9077 62 21.3867 62C9.57494 62.0001 0.000148426 71.5749 0 83.3867V0.613281Z')",
            zIndex: theme.zIndex.modal + 1,
          },
          "&.is-open": {
            "&:after": {
              opacity: 1,
              width: "45px",
              height: "84px",
            },
          },
        },
        openButton: {
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
          width: "86px",
          height: "138px",
          display: "flex",
          zIndex: theme.zIndex.modal + 2,
          borderRadius: "9999px",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          padding: theme.spacing(1.5),
          gap: theme.spacing(1.25),
          transition: `all ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeInOut}`,
          boxShadow:
            "0px 45px 13px 0px rgba(0, 0, 0, 0.00), 0px 29px 11px 0px rgba(0, 0, 0, 0.01), 0px 16px 10px 0px rgba(0, 0, 0, 0.05), 0px 7px 7px 0px rgba(0, 0, 0, 0.09), 0px 2px 4px 0px rgba(0, 0, 0, 0.10)",
          "&:hover": {
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
          },
          "&.is-open": {
            backgroundColor: theme.palette.background.default,
            height: "82px",
            width: "82px",
            "& .OrdinalSelector-openIconWrapper": {
              display: "none",
            },
            "& .OrdinalSelector-floorAvatar": {
              display: "none",
            },
            "& .OrdinalSelector-closeIconWrapper": {
              display: "inline-flex",
              color: theme.palette.text.secondary,
            },
          },
        },
        popoverRoot: {
          "& .MuiPaper-root": {
            width: "200px",
            height: "591px",
            boxShadow:
              " 0px 45px 13px 0px rgba(0, 0, 0, 0.00), 0px 29px 11px 0px rgba(0, 0, 0, 0.01), 0px 16px 10px 0px rgba(0, 0, 0, 0.05), 0px 7px 7px 0px rgba(0, 0, 0, 0.09), 0px 2px 4px 0px rgba(0, 0, 0, 0.10)",
            borderRadius: "24px",
            // !Force popover to stay fixed in the designed position (70% layout)
            left: "1112px !important",
            top: "195px !important",
          },
        },
        openIconWrapper: {
          backgroundColor: theme.palette.background.paper,
          height: "42px",
          width: "42px",
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "9999px",
          color: theme.palette.text.secondary,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          "& .MuiSvgIcon-root": {
            width: "24px",
            height: "24px",
          },
        },
        closeIconWrapper: {
          display: "none",
          "& .MuiSvgIcon-root": {
            width: "24px",
            height: "24px",
          },
        },
        scrollUpButton: {
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)",
          top: "56px", // logoWrapper's height (42px) + spacing (14px)
          backgroundColor: theme.palette.background.default,
          border: `1px solid ${theme.palette.divider}`,
          height: "42px",
          width: "42px",
          zIndex: 1,
          "&:hover": {
            backgroundColor: theme.palette.background.default,
          },
        },
        scrollDownButton: {
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)",
          bottom: "14px",
          backgroundColor: theme.palette.background.default,
          border: `1px solid ${theme.palette.divider}`,
          height: "42px",
          width: "42px",
          zIndex: 1,
          "&:hover": {
            backgroundColor: theme.palette.background.default,
          },
        },
        floorAvatar: {
          background:
            "url(https://s3.venue.in.th/ordinal_button_pattern_9027ebd907.svg)",
          width: "62px",
          height: "62px",
          backgroundSize: "contain",
          borderRadius: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "1.5rem",
          fontWeight: 700,
          color: theme.palette.primary.contrastText,
        },
        contentContainer: {
          position: "relative",
        },
        logoContainer: {
          display: "flex",
          flexDirection: "row",
          borderBottom: "1px solid transparent",
          borderImage:
            "linear-gradient(270deg, #EEE7CC 10.63%, #AC8700 51.45%, #EEE7CC 94.42%) 1",
          "&.ics": {
            order: 1,
          },
        },
        logoImage: {
          height: "18px",
        },
        logoWrapper: {
          height: "42px",
          background: theme.palette.background.paper,
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          flex: 1,
          padding: theme.spacing(1.5),
          "&.ics": {
            order: 1,
          },
          "&.iconsiam": {
            order: 1,
          },
        },
        levelContainer: {
          display: "flex",
          maxHeight: "548px",
          maskImage:
            "linear-gradient(to bottom, transparent, black 4%, black 90%, transparent)",
          height: "100%",
          overflow: "hidden auto",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        },
        levelList: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1.5),
          flex: 1,
          padding: theme.spacing(7, 0),
          alignItems: "center",
          height: "100%",
          "&.ics": {
            order: 1,
            background: "#E4E2E070",
          },
          "&.iconsiam": {
            order: 2,
          },
        },
        levelButton: {
          backgroundColor: "transparent",
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "50%",
          color: theme.palette.text.secondary,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "52px",
          width: "52px",
          fontSize: "1.25rem",
          padding: theme.spacing(1.5),
          position: "relative",
          backgroundSize: "contain",
          backgroundPosition: "center",
          flexShrink: 0,
          pointerEvents: "auto",
          "&.Mui-selected": {
            backgroundImage:
              "url(https://s3.venue.in.th/ordinal_button_pattern_9027ebd907.svg)",
            fontWeight: 700,
            color: theme.palette.primary.contrastText,
          },
          "&.is-unavailable": {
            pointerEvents: "none",
            visibility: "hidden",
          },
          "&.ics": {
            "&:not(.Mui-selected)": {
              backgroundImage:
                "url(https://s3.venue.in.th/ics_level_button_pattern_c3818c9801.svg)",
            },
            // Disable UG floor for ICS venue
            "&.ordinal-1": {
              pointerEvents: "none",
              visibility: "hidden",
            },
            "&.ordinal-2": {
              ":before": {
                content: "''",
                position: "absolute",
                left: "-4px",
                width: "160px",
                height: "60px",
                display: "inline-block",
                background:
                  "url(https://s3.venue.in.th/bts_floor_connector_90a03d0190.svg) center/contain no-repeat",
              },
            },
          },
        },
        currentLocationPopper: {
          pointerEvents: "none",
          "&[data-popper-placement*='right']": {},
          "& .MuiTooltip-tooltip": {
            backgroundColor: "transparent",
            padding: 0,
          },
        },
        currentLocation: {
          display: "inline-block",
          background:
            "url(https://s3.venue.in.th/ordinal_selector_you_are_here_7ab0f71938.png) center/contain no-repeat",
          width: 70,
          height: 55,
          zIndex: 1,
          animation: "horizontal-bounce 1.5s infinite",
        },
      },
    },
    DirectoryOccupantCard: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "374px",
          borderRadius: "8px",
          position: "relative",
          boxShadow: "none",
          border: "1px solid transparent",
          background:
            "linear-gradient(180deg, #FFFFFF 71%, #EDEEEE 100%, #FFF) padding-box, linear-gradient(333deg, #D6C380 30%, #EEE7CC 81.85%) border-box",
        },
        occupantLogo: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          boxShadow: "none",
          minWidth: "100%",
          "& .MuiAvatar-root": {
            borderRadius: "0",
            width: "100%",
            height: "220px",
            "& .MuiSvgIcon-root": {
              width: "56px",
              height: "56px",
            },
          },
          "& .MuiAvatar-img": {
            objectFit: "cover",
          },
        },
        cardContent: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: theme.spacing(1.5),
          paddingBottom: theme.spacing(0),
          height: "100%",
          width: "100%",
          "& .MuiTypography-root": {
            lineHeight: 1.4,
          },
        },
        levelAvatar: {
          width: 32,
          height: 32,
          fontSize: "0.875rem",
          fontWeight: 700,
          marginRight: theme.spacing(-0.5),
          color: theme.palette.primary.contrastText,
          background:
            "url(https://s3.venue.in.th/level_Icon_b460ba199f.svg) , no-repeat",
        },
        divider: {
          display: "flex",
          borderBottomWidth: "1px",
          borderImage:
            "linear-gradient(291deg, #EEE7CC 0%, #AC8700 50%, #EEE7CC 100%) 1",
        },
        venueLogo: {
          display: "flex",
          objectFit: "contain",
          height: "100%",
          width: "90px",
        },
        titleText: {
          fontSize: "1rem",
          fontWeight: 700,
          flexGrow: 1,
          color: theme.palette.text.primary,
          height: "42px",
        },
        detailWrapper: {
          display: "flex",
          flexDirection: "column",
          height: "auto",
          padding: 0,
        },
        infoContainer: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: 0,
          alignItems: "center",
          height: "44px",
        },
        categoryText: {
          fontSize: "0.75rem",
          fontWeight: 300,
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          WebkitLineClamp: 1,
          color: "#6A6A6A",
          marginBottom: theme.spacing(1),
        },
        chipContainer: {
          position: "absolute",
          display: "flex",
          top: 0,
          width: "100%",
          zIndex: 2,
          padding: theme.spacing(0.75),
        },
        newShopChip: {
          display: "flex",
        },
        adsChip: {
          marginRight: "auto",
          padding: theme.spacing(1),
          height: "20px",
          borderRadius: "24px",
          backgroundColor: "rgba(73, 70, 86, 0.6)",
          "& .MuiChip-label": {
            padding: 0,
            fontSize: "0.75rem",
            fontWeight: 400,
            color: "#E2E2E4",
          },
        },
        comingSoonChip: {
          display: "flex",
        },
        vatRefundChip: {
          display: "flex",
          width: "100%",
          maxWidth: "112px",
          marginBottom: theme.spacing(0.5),
          "& .MuiChip-label": {
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
        },
        multiLevelContainer: {
          display: "flex",
          marginRight: theme.spacing(-0.5),
          "& > *:first-of-type": {
            borderRadius: "16px 0 0 16px",
            width: 36,
            paddingLeft: theme.spacing(0.5),
            borderRight: `0.4px solid ${theme.palette.divider}`,
          },
          "& > *:last-of-type": {
            borderRadius: "0 16px 16px 0",
            width: 36,
            paddingRight: theme.spacing(0.5),
          },
          "& > *:not(:first-of-type):not(:last-of-type)": {
            borderRadius: 0,
            borderRight: `0.4px solid ${theme.palette.divider}`,
          },
        },
        multiLevelAvatar: {
          width: 32,
          height: 32,
          fontSize: "0.875rem",
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: theme.palette.primary.contrastText,
          backgroundColor: theme.palette.primary.main,
        },
      },
    },
    DirectorySkeletonCard: {
      styleOverrides: {
        root: {
          flexDirection: "column",
          borderRadius: "8px",
          boxShadow: "none",
          width: "222px",
          height: "374px",
          border: "1px solid transparent",
          background:
            "linear-gradient(180deg, #FFFFFF 71%, #EDEEEE 100%, #FFF) padding-box, linear-gradient(333deg,rgb(203, 195, 165) 30%, #EEE7CC 81.85%) border-box",
        },
        avatar: {
          boxShadow: "none",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flex: "0 0 222px",
          width: "100%",
          height: "100%",
          minWidth: "222px",
          maxWidth: "unset",
        },
        logo: {
          boxShadow: "none",
          order: 9999,
          height: "40px",
          margin: theme.spacing(1.5),
          marginTop: "auto",
        },
        cardContent: {
          padding: theme.spacing(1.5),
        },
      },
    },
    AppDining: {
      styleOverrides: {
        pageCard: {
          background:
            "url(https://s3.venue.in.th/floorplan_bg_iconsiam_kiosk_h_1f69ed0abe.svg) no-repeat center/cover",
          "&:after": {
            display: "none",
          },
        },
        pageCardContent: {
          padding: 0,
        },
        contentWrapper: {
          position: "relative",
        },
        gridItem: {
          width: "223px",
          height: "345px",
        },
        gridContainer: {
          padding: theme.spacing(0, 13.5),
          gap: theme.spacing(2.5),
          gridAutoFlow: "row",
          height: "925px",
          overflow: "hidden auto",
          gridTemplateRows: "repeat(3, max-content)",
          gridTemplateColumns: "repeat(5, max-content)",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        },
        filterWrapper: {
          marginTop: theme.spacing(3),
          padding: theme.spacing(0, 13.5),
        },
        filterContainer: {},
        venueSelector: {
          display: "flex",
          position: "absolute",
          bottom: "80px",
          left: "50%",
          right: "unset",
          transform: "translateX(-50%)",
        },
      },
    },
    DiningCard: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          minHeight: "345px",
          height: "345px",
          width: "223px",
          maxWidth: "223px",
          borderRadius: "8px",
          position: "relative",
          background:
            "linear-gradient(180deg, #FFFFFF 71%, #EDEEEE 100%, #FFF) padding-box, linear-gradient(333deg, #D6C380 30%, #EEE7CC 81.85%) border-box",
          border: "1px solid transparent",
          boxShadow: "none",
        },
        featuredImage: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          boxShadow: "none",
          flexDirection: "column",
          position: "relative",
          "& .MuiAvatar-root": {
            borderRadius: "0",
            width: "223px",
            height: "216px",
          },
          "& .MuiAvatar-img": {
            objectFit: "cover",
          },
          "& .MuiSvgIcon-root": {
            width: 64,
            height: 64,
          },
        },
        cardContent: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: theme.spacing(5, 1, 0),
          height: "129px",
          minHeight: "129px",
        },
        levelAvatar: {
          width: 32,
          height: 32,
          fontSize: "0.875rem",
          fontWeight: 700,
          color: theme.palette.common.white,
          background:
            "url(https://s3.venue.in.th/level_Icon_b460ba199f.svg) , no-repeat",
          marginRight: theme.spacing(-0.5),
        },
        venueLogo: {
          objectFit: "contain",
          maxHeight: "44px",
          maxWidth: "90px",
        },
        titleText: {
          color: theme.palette.text.primary,
          fontSize: "1.125rem",
          lineHeight: 1.4,
          fontWeight: 700,
          textOverflow: "ellipsis",
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          maxHeight: "54px",
        },
        detailWrapper: {
          display: "flex",
          gap: theme.spacing(0.75),
          flexDirection: "column",
        },
        infoContainer: {
          minHeight: "44px",
          height: "44px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: 0,
          alignItems: "center",
        },
        logo: {
          width: 68,
          height: 68,
          marginTop: theme.spacing(-9.75),
          borderRadius: "8px",
          border: `2px solid ${theme.palette.common.white}`,
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.secondary,
          "& .MuiAvatar-img": {
            borderRadius: "6px",
          },
        },
        chipContainer: {
          display: "flex",
          padding: theme.spacing(0.75),
          left: 0,
          right: 0,
          top: 0,
          position: "absolute",
          zIndex: 1,
        },
        chip: {
          width: 32,
          height: 32,
          borderRadius: "100px",
          background:
            "linear-gradient(293deg, #C8AF55 24.06%,  #EEE7CC 90.57%)",
          "& .MuiChip-label": {
            padding: 0,
            display: "flex",
            alignItems: "center",
          },
          "& .MuiSvgIcon-root": {
            width: 20,
            height: 20,
            fill: theme.palette.primary.main,
          },
        },
        newShopChip: {
          display: "flex",
        },
        adsChip: {
          marginLeft: "auto",
          padding: theme.spacing(1),
          height: "20px",
          borderRadius: "24px",
          backgroundColor: "rgba(73, 70, 86, 0.6)",
          "& .MuiChip-label": {
            padding: 0,
            fontSize: "0.75rem",
            fontWeight: 400,
            color: "#E2E2E4",
          },
        },
        comingSoonChip: {
          display: "flex",
        },
        vatRefundChip: {
          display: "flex",
          position: "absolute",
          bottom: "8px",
          left: "80px",
          zIndex: 1,
        },
        multiLevelContainer: {
          display: "flex",
          marginRight: theme.spacing(-0.5),
          "& > *:first-of-type": {
            borderRadius: "16px 0 0 16px",
            width: 36,
            paddingLeft: theme.spacing(0.5),
            borderRight: `0.4px solid ${theme.palette.divider}`,
          },
          "& > *:last-of-type": {
            borderRadius: "0 16px 16px 0",
            width: 36,
            paddingRight: theme.spacing(0.5),
          },
          "& > *:not(:first-of-type):not(:last-of-type)": {
            borderRadius: 0,
            borderRight: `0.4px solid ${theme.palette.divider}`,
          },
        },
        multiLevelAvatar: {
          width: 32,
          height: 32,
          fontSize: "0.875rem",
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: theme.palette.primary.contrastText,
          backgroundColor: theme.palette.primary.main,
        },
      },
    },
    PromotionPage: {
      defaultProps: {
        promotionCarouselOption: {
          limitPaginations: 7,
        },
      },
      styleOverrides: {
        carouselContainer: {
          display: "flex",
          flexDirection: "column",
          position: "relative",
          width: 1410,
          alignItems: "center",
          justifyContent: "center",
          flexGrow: 1,
          margin: theme.spacing(-5, -4, 0),
          "&:before": {
            content: "''",
            position: "absolute",
            width: "65px",
            height: "100%",
            background:
              "linear-gradient(90deg, rgba(256, 256, 256, 1) 0%, rgba(256, 256, 256, 0) 100%)",
            left: 0,
            zIndex: 1,
          },
          "&:after": {
            content: "''",
            position: "absolute",
            width: "65px",
            height: "100%",
            background:
              "linear-gradient(-90deg, rgba(256, 256, 256, 1) 0%, rgba(256, 256, 256, 0) 100%)",
            right: 0,
            zIndex: 1,
          },
          '[dir="rtl"] &': {
            "&:before": {
              background:
                "linear-gradient(-90deg, rgba(256, 256, 256, 1) 0%, rgba(256, 256, 256, 0) 100%)",
            },
            "&:after": {
              background:
                "linear-gradient(90deg, rgba(256, 256, 256, 1) 0%, rgba(256, 256, 256, 0) 100%)",
            },
          },
        },
        carousel: {
          width: "100%",
          "& .splide": {
            margin: "0 auto",
          },
          "& .splide__pagination": {
            marginTop: theme.spacing(3.75),
          },
          "& .splide__pagination__page": {
            width: "16px",
            height: "16px",
          },
          "& .splide__pagination__page.is-active": {
            backgroundColor: theme.palette.primary.main,
            transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}, borderRadius ${theme.transitions.duration.standard}s ${theme.transitions.easing.easeInOut} `,
            transform: "none",
            width: "20px",
            height: "20px",
            borderRadius: 30,
          },
          "& .splide__track": {
            margin: theme.spacing(-3.75),
            padding: theme.spacing(0, 3.75),
          },
          "& .splide__slide": {
            width: "384px !important ",
            "&> *": {
              display: "inline-block",
              transform: "scale(1)",
              opacity: 1,
              transition: `all ${theme.transitions.duration.short} ms`,
            },
            "&.is-visible.is-active": {
              "&> *": {
                opacity: 1,
                transform: "scale(1)",
              },
            },
          },
        },
        pageCardContent: {
          display: "flex",
          flexDirection: "column",
        },
        pageCard: {},
        emptyDataContainer: {
          background:
            "url(https://s3.venue.in.th/floorplan_bg_iconsiam_kiosk_h_1f69ed0abe.svg)",
          height: "1000px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          margin: theme.spacing(-3, -4),
        },
        venueSelector: {
          display: "block",
          position: "absolute",
          left: "50%",
          bottom: "-2px",
          transform: "translate(-50%, -50%)",
        },
      },
    },
    VuiDetailCard: {
      styleOverrides: {
        card: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(5),
          padding: theme.spacing(5),
          "&.no-description": {
            gridTemplateAreas:
              "'img title' \n 'img info' \n 'img qr' \n 'img qr' \n 'img qr'",
            "& .VuiDetailCard-cardContent": {
              display: "none",
            },
          },
          "&.VuiDetailCard-card--occupant-promotion": {
            "& .VuiDetailCard-cardContentSecondaryText": {
              maxHeight: "290px ",
            },
          },
        },
        infoListItem: {
          "& .MuiAvatar-root": {
            background: "#ECECED",
            borderRadius: "8px",
            color: theme.palette.text.primary,
            width: 56,
            height: 56,
            marginRight: "24px",
            "& .MuiSvgIcon-root": {
              height: 32,
              width: 32,
              "& svg *": {
                fill: theme.palette.text.primary,
                stopColor: theme.palette.text.primary,
              },
            },
          },
          "& .MuiListItemText-root": {
            "& .MuiListItemText-primary": {
              fontSize: "1.25rem",
              color: theme.palette.text.primary,
              fontWeight: 700,
              textTransform: "uppercase",
              "& .MuiTypography-root": {
                fontSize: "1.25rem",
                color: theme.palette.text.primary,
                fontWeight: 700,
              },
            },
            "& .MuiListItemText-secondary": {
              fontSize: "1rem",
              color: theme.palette.text.secondary,
            },
          },
          "&:last-of-type": {
            "& .MuiListItemText-root": {
              "& .MuiListItemText-secondary": {
                display: "none",
              },
            },
          },
        },
        cardHeader: {
          padding: 0,
          paddingBottom: 0,
          width: "100%",
          alignItems: "flex-start",
          "& .MuiCardHeader-title": {
            fontSize: "1.75rem",
            fontWeight: 700,
            overflow: "hidden",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2,
            height: 66,
          },
          "& .MuiCardHeader-action": {
            marginRight: 0,
          },
        },
        cardContent: {
          padding: 0,
          paddingTop: theme.spacing(1),
        },
        cardContentPrimaryText: {
          color: theme.palette.text.primary,
          fontWeight: 700,
          fontSize: "1.25rem",
          marginBottom: theme.spacing(1),
        },
        cardContentSecondaryText: {
          color: theme.palette.text.secondary,
          minHeight: 66,
          maxHeight: 202, // max height calculate from full content of section
          overflowY: "auto",
          fontSize: "1rem",
        },
        pageCard: {},
        pageCardContent: {},
        emptyDataContainer: {},
        infoContainer: {
          padding: 0,
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(2.5),
        },
        qrCodeContainer: {
          width: 374,
          height: 155,
          borderRadius: "16px",
          border: `1px solid ${theme.palette.divider}`,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          padding: theme.spacing(3, 1),
        },
        qrCode: {
          height: 132,
          width: 132,
          border: 0,
          padding: 0,
          "&:before": {
            display: "none",
          },
          "&:after": {
            display: "none",
          },
          "& .AppQRCode-content": {
            height: 132,
            width: 132,
            padding: theme.spacing(1.5),
            "&.MuiCardContent-root:last-child": {
              paddingBottom: theme.spacing(1.5),
            },
            "&:before": {
              display: "none",
            },
            "&:after": {
              display: "none",
            },
          },
        },
        qrcodePrimaryText: {
          fontSize: "1.5rem",
        },
        qrcodeSecondaryText: {
          fontSize: "1.125rem",
        },
        buttonContainer: {
          marginTop: "auto",
          display: "flex",
          gap: theme.spacing(1),
          justifyContent: "center",
          alignItems: "flex-end",
          flex: 1,
        },
        button: {
          height: 80,
          width: 258,
          "&.MuiButton-outlinedPrimary": {
            color: theme.palette.text.primary,
          },
        },
        cardContentTextWrapper: {},
        cardMediaWrapper: {},
        galleryCarouselWrapper: {
          height: 874,
          width: 476,
        },
        galleryCarousel: {
          "& .splide__track": {
            margin: 0,
            padding: 0,
          },
        },
        galleryCarouselItem: {
          width: "476px !important",
          height: 846,
          borderRadius: "20px",
        },
        contentWrapper: {
          display: "flex",
          flexDirection: "column",
          flex: 1,
          paddingTop: theme.spacing(3),
          gap: theme.spacing(5),
        },
        galleryCarouselModal: {
          "&.VuiDetailCard-galleryCarouselModal--promotion, &.VuiDetailCard-galleryCarouselModal--event":
            {
              "& .AppImageCarouselModal-carousel": {
                transform: "translateY(-40px)",
              },
              "& .AppImageCarouselModal-image": {
                width: "506px",
                height: "900px",
              },
              "& .AppImageCarouselModal-carouselItem": {
                maxWidth: "530px",
              },
              "& .AppImageCarouselModal-closeButton": {
                top: "910px",
                zIndex: 2,
                width: "82px",
                height: "82px",
              },
              "& .splide__pagination": {
                marginTop: theme.spacing(1.5),
              },
            },
        },
      },
    },
    ServicePage: {
      styleOverrides: {
        pageCard: {
          background:
            "url(https://s3.venue.in.th/floorplan_bg_iconsiam_kiosk_h_1f69ed0abe.svg) no-repeat center/cover",
          overflow: "hidden",
        },
        pageCardContent: {
          padding: 0,
          overflow: "hidden auto",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        },
        gridContainer: {
          width: "100%",
          display: "grid",
          gridTemplateRows: "repeat(2,max-content)",
          gridTemplateColumns: "repeat(2,max-content)",
          gap: theme.spacing(4),
          padding: theme.spacing(0, 13.5),
        },
        gridItem: {
          display: "flex",
          flexDirection: "column",
          width: "580px",
          gap: theme.spacing(4),
          overflow: "auto",
        },
        emptyDataContainer: {
          minHeight: "820px",
          marginTop: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
        venueSelector: {
          display: "flex",
          position: "absolute",
          bottom: "30px",
          left: "50%",
          right: "unset",
          transform: "translateX(-50%)",
          zIndex: 2,
        },
      },
    },
    ServiceCard: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          borderRadius: "16px",
          overflow: "hidden",
          border: `1px solid ${theme.palette.divider}`,
          "&:first-of-type": {
            borderRadius: "16px",
          },
          "&:last-of-type": {
            borderRadius: "16px",
          },
          "&:before": {
            display: "none",
          },
          "&.Mui-expanded": {
            margin: 0,
          },
        },
        accordionSummary: {
          height: "282px",
          padding: theme.spacing(5, 3, 2.5),
          gap: theme.spacing(3),
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          alignItems: "flex-end",
          ":after": {
            content: "''",
            position: "absolute",
            top: 0,
            right: "-1px",
            left: "-1px",
            bottom: "-1px",
            zIndex: 0,
            background: `linear-gradient(180deg, rgba(255, 255, 255, 0.00) 19.68%, #FFF 67.87%)`,
          },
          "& .MuiAccordionSummary-expandIconWrapper": {
            color: theme.palette.text.secondary,
            marginBottom: theme.spacing(5),
            zIndex: 1,
            "& .MuiSvgIcon-root": {
              width: "24px",
              height: "24px",
            },
          },
          "& .MuiAccordionSummary-content": {
            margin: 0,
          },
        },
        coverImage: {
          backgroundPosition: "right center",
          backgroundRepeat: "no-repeat",
          backgroundColor: "#ffffffcc",
          backgroundBlendMode: "lighten",
          backgroundSize: "cover",
          filter: "grayscale(100%)",
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          width: "60%",
        },
        summaryContainer: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(4),
          alignItems: "center",
          zIndex: 1,
        },
        titleText: {
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          WebkitLineClamp: 1,
          fontSize: "1.5rem",
          fontWeight: 700,
          color: theme.palette.primary.main,
          lineHeight: 1.1,
        },
        descriptionText: {
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
          wordBreak: "break-word",
          color: theme.palette.text.secondary,
          fontSize: "1.25rem",
          lineHeight: 1.1,
        },
        serviceIconContainer: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "64px",
          height: "64px",
          background: "#ECECED",
        },
        serviceIcon: {
          color: theme.palette.text.secondary,
          width: "40px",
          height: "40px",
        },
        infoContainer: {
          height: "84px",
          display: "flex",
          justifyContent: "flex-start",
          flexDirection: "column",
          gap: theme.spacing(1.5),
        },
        accordionDetails: {
          padding: theme.spacing(1.5),
          backgroundColor: theme.palette.primary.contrastText,
        },
        locationList: {
          padding: theme.spacing(0, 1.5),
          overflow: "hidden auto",
          maxHeight: "380px",
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            background: theme.palette.text.secondary,
            borderRadius: "9999px",
          },
        },
        locationListItem: {
          height: "76px",
          borderBottom: `1px solid ${theme.palette.divider}`,
          padding: theme.spacing(2, 3.75, 2, 0),
          "&:last-of-type": {
            borderBottom: "none",
          },
          "&.ServiceCard-locationListItem--highlight": {
            padding: theme.spacing(2, 5.75, 2, 2),
            width: "calc(100% + 16px)",
            margin: theme.spacing(0, -1),
            borderRadius: "20px",
            border: "1px solid #C8AF55",
            background:
              "linear-gradient(333deg, rgba(200, 175, 85, 0.40) 31.92%, rgba(238, 231, 204, 0.40) 81.85%)",
            "& .ServiceCard-locationNavigateButton": {
              color: theme.palette.primary.main,
              marginRight: theme.spacing(-2),
            },
            "& .ServiceCard-listNameText": {
              color: theme.palette.primary.main,
              fontWeight: 700,
              fontSize: "1rem",
            },
            "& .ServiceCard-floorTextAvatar": {},
          },
        },
        locationNavigateButton: {
          color: theme.palette.text.secondary,
          marginRight: theme.spacing(-3),
          "& .MuiSvgIcon-root": {
            width: "24px",
            height: "24px",
          },
        },
        floorTextAvatar: {
          minWidth: "unset",
          width: 32,
          height: 32,
          fontWeight: 700,
          color: theme.palette.primary.contrastText,
          borderRadius: "50%",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "0.875rem",
          display: "flex",
          marginLeft: "auto",
          lineHeight: 1.1,
          background:
            "url(https://s3.venue.in.th/level_Icon_b460ba199f.svg) , no-repeat",
        },
        venueLogo: {
          maxHeight: 32,
          maxWidth: 90,
          objectFit: "contain",
        },
        venueLogoWrapper: {
          width: 90,
          height: 32,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        locationLogoWrapper: {
          width: 32,
          height: 32,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginRight: theme.spacing(1.5),
        },
        locationLogo: {
          maxHeight: 32,
          maxWidth: 32,
          borderRadius: "4px",
        },
        divider: {
          border: "1px solid",
          height: "32px",
          margin: theme.spacing(0, 1.5),
          borderImage:
            "linear-gradient(to bottom, #EEE7CC 0%, #AC8700 50%, #EEE7CC 100%) 1",
        },
        listNameText: {
          fontSize: "1.1875rem",
          lineHeight: 1.1,
          color: theme.palette.text.secondary,
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          width: "188px",
        },
      },
    },
    EventPage: {
      defaultProps: {
        eventCarouselOption: {
          limitPaginations: 7,
        },
      },
      styleOverrides: {
        carouselContainer: {
          display: "flex",
          flexDirection: "column",
          position: "relative",
          width: 1410,
          alignItems: "center",
          justifyContent: "center",
          flexGrow: 1,
          margin: theme.spacing(-5, -4, 0),
          top: 0,
          "&:before": {
            content: "''",
            position: "absolute",
            width: "65px",
            height: "100%",
            background:
              "linear-gradient(90deg, rgba(256, 256, 256, 1) 0%, rgba(256, 256, 256, 0) 100%)",
            left: 0,
            zIndex: 1,
          },
          "&:after": {
            content: "''",
            position: "absolute",
            width: "65px",
            height: "100%",
            background:
              "linear-gradient(-90deg, rgba(256, 256, 256, 1) 0%, rgba(256, 256, 256, 0) 100%)",
            right: 0,
            zIndex: 1,
          },
          '[dir="rtl"] &': {
            "&:before": {
              background:
                "linear-gradient(-90deg, rgba(256, 256, 256, 1) 0%, rgba(256, 256, 256, 0) 100%)",
            },
            "&:after": {
              background:
                "linear-gradient(90deg, rgba(256, 256, 256, 1) 0%, rgba(256, 256, 256, 0) 100%)",
            },
          },
        },
        carousel: {
          width: "100%",
          "& .splide": {
            margin: "0 auto",
          },
          "& .splide__pagination": {
            marginTop: "30px",
          },
          "& .splide__pagination__page": {
            width: "16px",
            height: "16px",
          },
          "& .splide__pagination__page.is-active": {
            backgroundColor: theme.palette.primary.main,
            transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}, borderRadius ${theme.transitions.duration.standard}s ${theme.transitions.easing.easeInOut} `,
            transform: "none",
            width: "20px",
            height: "20px",
            borderRadius: 30,
          },
          "& .splide__track": {
            margin: theme.spacing(-3.75),
            padding: theme.spacing(0, 3.75),
          },
          "& .splide__slide": {
            width: "384px !important ",
            "&> *": {
              display: "inline-block",
              transform: "scale(1)",
              opacity: 1,
              transition: `all ${theme.transitions.duration.short} ms`,
            },
            "&.is-visible.is-active": {
              "&> *": {
                opacity: 1,
                transform: "scale(1)",
              },
            },
          },
        },
        pageCardContent: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          gap: 0,
          "&:after": {
            display: "none",
          },
        },
        pageCard: {},
        emptyDataContainer: {
          background:
            "url(https://s3.venue.in.th/floorplan_bg_iconsiam_kiosk_h_1f69ed0abe.svg)",
          height: "1000px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          margin: theme.spacing(-3, -4),
        },
        venueSelector: {
          display: "block",
          position: "absolute",
          left: "50%",
          bottom: "-2px",
          transform: "translate(-50%, -50%)",
        },
      },
    },
    OccupantPromotionPage: {
      defaultProps: {
        promotionCarouselOption: {
          limitPaginations: 7,
        },
      },
      styleOverrides: {
        carouselContainer: {
          display: "flex",
          flexDirection: "column",
          position: "relative",
          width: 1225,
          alignItems: "center",
          justifyContent: "center",
          flexGrow: 1,
          margin: theme.spacing(0, -4),
          paddingTop: theme.spacing(8.25),
          "&:before": {
            content: "''",
            position: "absolute",
            width: "105px",
            height: "100%",
            background:
              "linear-gradient(90deg, rgba(248,248,255, 1) 0%, rgba(248,248,255, 0) 100%)",
            left: 0,
            zIndex: 1,
          },
          "&:after": {
            content: "''",
            position: "absolute",
            width: "105px",
            height: "100%",
            background:
              "linear-gradient(-90deg, rgba(248,248,255, 1) 0%, rgba(248,248,255, 0) 100%)",
            right: 0,
            zIndex: 1,
          },
          "[dir='rtl'] &": {
            "&:before": {
              background:
                "linear-gradient(-90deg, rgba(248,248,255, 1) 0%, rgba(248,248,255, 0) 100%)",
            },
            "&:after": {
              background:
                "linear-gradient(90deg, rgba(248,248,255, 1) 0%, rgba(248,248,255, 0) 100%)",
            },
          },
        },
        carousel: {
          width: "100%",
          height: "100%",
          "& .splide": {
            margin: "0 auto",
          },
          "& .splide__pagination": {
            marginTop: theme.spacing(5),
          },
          "& .splide__pagination__page": {
            width: "16px",
            height: "16px",
          },
          "& .splide__pagination__page.is-active": {
            backgroundColor: theme.palette.primary.main,
            width: "20px",
            height: "20px",
          },
          "& .splide__track": {
            margin: theme.spacing(-3.75),
            padding: theme.spacing(0, 3.75),
          },
          "& .splide__slide": {
            width: "384px !important ",
            "&> *": {
              display: "inline-block",
              transform: "scale(1)",
              opacity: 0.6,
              transition: `all ${theme.transitions.duration.short} ms`,
            },
            "&.is-visible.is-active": {
              "&> *": {
                opacity: 1,
                transform: "scale(1)",
              },
            },
          },
        },
        pageCardContent: {
          display: "flex",
          flexDirection: "column",
        },
        pageCard: {
          background:
            "url(https://s3.venue.in.th/place_detail_backgrounf_iconsiam_kiosk_h_081d7cd01d.svg)",
        },
        emptyDataContainer: {},
        venueSelector: {
          position: "absolute",
          left: "50%",
          bottom: "-2px",
          transform: "translate(-50%, -50%)",
        },
      },
    },
    OccupantRecommendedMenuPage: {
      styleOverrides: {
        pageCard: {
          background:
            "url(https://s3.venue.in.th/place_detail_backgrounf_iconsiam_kiosk_h_081d7cd01d.svg)",
        },
        pageCardContent: {
          padding: 0,
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(3),
        },
        pageCardHeaderText: {
          fontSize: "2.5rem",
          fontWeight: 700,
        },
        productContainer: {
          display: "grid",
          gridTemplateColumns: "repeat(6, 1fr)",
          gridAutoRows: "max-content",
          gap: theme.spacing(3),
          width: "100%",
          height: "908px",
          overflow: "hidden auto",
          paddingBottom: theme.spacing(5),
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            background: theme.palette.text.secondary,
            borderRadius: "9999px",
          },
          "&:after": {
            content: "' '",
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            background:
              "linear-gradient(180deg, rgba(248, 248, 255, 0) 0%, #F8F8FF 100%)",
            height: "80px",
            pointerEvents: "none",
          },
        },
        productCard: {
          gridColumn: "span 2",
          "&.highlight,:nth-child(1),:nth-child(2)": {
            width: "600px",
            gridColumn: "span 3",
            "& .ProductModal-fallbackCardMediaIcon": {
              width: "102px",
              height: "102px",
            },
          },
        },
      },
    },
    ReservationPage: {
      styleOverrides: {
        pageCard: {
          background:
            "url(https://s3.venue.in.th/place_detail_backgrounf_iconsiam_kiosk_h_081d7cd01d.svg)",
        },
        pageCardContent: {
          padding: 0,
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(3),
        },
        pageCardHeaderText: {
          fontSize: "2.5rem",
          fontWeight: 700,
        },
        reservationContainer: {
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gridAutoRows: "max-content",
          gap: theme.spacing(3),
          width: "100%",
          height: "908px",
          overflow: "hidden auto",
          paddingBottom: theme.spacing(5),
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            background: theme.palette.text.secondary,
            borderRadius: "9999px",
          },
          "&:after": {
            content: "' '",
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            background:
              "linear-gradient(180deg, rgba(248, 248, 255, 0) 0%, #F8F8FF 100%)",
            height: "80px",
            pointerEvents: "none",
          },
        },
        reservationCard: {
          width: "392px",
        },
      },
    },
    ReservationQRCodeCard: {
      styleOverrides: {
        root: {
          padding: theme.spacing(4),
          display: "grid",
          width: "392px",
          height: "440px",
          boxShadow: "none",
          borderRadius: "24px",
          gridTemplateAreas: `
          "logo textContainer"
          "divider divider"
          "content content"
          `,
          gridTemplateRows: "92px 1px 1fr",
          gridTemplateColumns: "92px 1fr",
          gap: theme.spacing(6, 5),
        },
        logoContainer: {
          gridArea: "logo",
        },
        logo: {
          width: "92px",
          height: "92px",
          borderRadius: "12px",
        },
        fallbackLogoIcon: {
          width: "42px",
          height: "42px",
        },
        divider: {
          gridArea: "divider",
        },
        textContainer: {
          gridArea: "textContainer",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
        },
        labelImage: { objectFit: "contain", width: "120px" },
        primaryText: {
          fontSize: "1.5rem",
          fontWeight: 700,
        },
        secondaryText: {
          fontSize: "1.25rem",
          fontWeight: 400,
        },
        content: {
          gridArea: "content",
        },
        qrCodeContainer: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          gap: theme.spacing(5),
          height: "100%",
          width: "100%",
        },
        qrCodeListItem: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: theme.spacing(1),
        },
        qrCode: {
          padding: theme.spacing(0, 0.5),
          border: "none",
          width: "140px",
          height: "140px",
          "& .AppQRCode-content": {
            width: "140px",
            height: "140px",
          },
          "& .AppQRCode-qrcode": {
            border: "none",
          },
        },
      },
    },
    ReservationContactCard: {
      styleOverrides: {
        root: {
          position: "relative",
          padding: theme.spacing(4),
          display: "grid",
          width: "392px",
          height: "440px",
          boxShadow: "none",
          borderRadius: "24px",
          gridTemplateAreas: `
          "logo labelContainer"
          "divider divider"
          "textContainer textContainer"
          `,
          gridTemplateRows: "92px 1px 1fr",
          gridTemplateColumns: "92px 1fr",
          gap: theme.spacing(6, 5),
          "&:after": {
            content: "''",
            display: "inline-block",
            height: "30px",
            width: "100%",
            background: "linear-gradient(180deg,transparent,#ffffff);",
            maskImage:
              "linear-gradient(0deg, #000 0%, rgba(0, 0, 0, 0.00) 100%)",
            zIndex: 1,
            position: "absolute",
            right: 0,
            bottom: "30px",
            left: 0,
            pointerEvents: "none",
          },
        },
        logoContainer: {
          gridArea: "logo",
        },
        logo: {
          width: "92px",
          height: "92px",
          background: "transparent",
        },
        fallbackLogoIcon: {
          width: "92px",
          height: "92px",
          color: "#C6C5C9",
        },
        divider: {
          gridArea: "divider",
        },
        labelContainer: {
          gridArea: "labelContainer",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
        },
        textContainer: {
          position: "relative",
          gridArea: "textContainer",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          overflow: "hidden auto",
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            background: theme.palette.text.secondary,
            borderRadius: "9999px",
          },
        },
        list: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1),
          maxHeight: "100%",
        },
        label: {
          fontSize: "1.5rem",
          fontWeight: 700,
          margin: 0,
        },
        contactTypeLabel: {
          fontSize: "1.25rem",
          fontWeight: 400,
          margin: 0,
        },
        primaryText: {
          fontSize: "1.5rem",
          fontWeight: 700,
          margin: 0,
        },
      },
    },
    ProductCard: {
      styleOverrides: {
        root: {
          position: "relative",
          width: "392px",
          aspectRatio: "1 / 1",
          borderRadius: "8px",
          boxShadow: "none",
        },
        cardMedia: {
          width: "100%",
          height: "100%",
          "&:after": {
            content: "''",
            display: "inline-block",
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 0,
            background:
              "linear-gradient(180deg, rgba(0, 0, 0, 0.10) 64.15%, rgba(0, 0, 0, 0.84) 99.87%)",
          },
        },
        cardContent: {
          position: "absolute",
          bottom: 0,
          left: 0,
          padding: theme.spacing(1.5),
        },
        cardTitle: {
          color: theme.palette.primary.contrastText,
          fontSize: "1.25rem",
          lineHeight: 1.5,
          fontWeight: 500,
          textOverflow: "ellipsis",
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          width: "80%",
          maxHeight: "77px",
        },
        fallbackCardMedia: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          width: "100%",
        },
        fallbackCardMediaIcon: {
          color: theme.palette.grey[400],
          width: "80px",
          height: "80px",
        },
      },
    },
    PromotionCard: {
      styleOverrides: {
        root: {
          width: "384px",
          minHeight: "786px",
          background:
            "linear-gradient(180deg, #FFFFFF 71%, #EDEEEE 100%) padding-box, linear-gradient(333deg, #D6C380 30%, #EEE7CC 81.85%) border-box",
          border: "1px solid transparent",
          borderRadius: "24px",
          boxShadow: "none",
          display: "flex",
          flexDirection: "column",
          padding: 0,
        },
        cardMedia: {
          width: "384px",
          height: "636px",
          maxHeight: "none",
          borderRadius: "none",
          objectFit: "cover",
          position: "relative",
        },
        duration: {
          color: "#948A8D",
          fontSize: "1rem",
          margin: 0,
        },
        cardTitle: {
          color: "#56464A",
          fontSize: "1.25rem",
          height: "56px",
          lineHeight: 1.3,
          fontWeight: 600,
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
          wordBreak: "break-word",
          "&.MuiTypography-root": {
            fontSize: "1.25rem",
          },
        },
        cardContent: {
          padding: theme.spacing(2),
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          "&:last-child": {
            paddingBottom: theme.spacing(3),
          },
          "&.MuiCardContent-root:last-child": {
            paddingBottom: 0,
          },
          "& .MuiTypography-root": {
            fontSize: "1rem",
          },
        },
        cardInfoContainer: {
          height: 42,
          position: "relative",
          marginTop: "8px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          "& .MuiTypography-root": {
            fontSize: "1rem",
            color: "#948A8D",
          },
        },
        venueLogoContainer: {
          display: "flex",
          position: "absolute",
          margin: theme.spacing(1.5, 2),
          bottom: 0,
          right: 0,
          "& .MuiCardMedia-root": {
            maxWidth: "90px",
            maxHeight: "43px",
          },
        },
        iconContainer: {
          width: "auto",
          marginRight: theme.spacing(1),
          "& .MuiSvgIcon-root": {
            height: "24px",
            width: "24px",
            color: theme.palette.primary.main,
          },
        },
        statusTextContainer: {
          width: "100%",
          backgroundColor: "#EFBB00",
          position: "absolute",
          padding: theme.spacing(0.75, 1.5),
          bottom: 0,
          left: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "52px",
        },
        statusText: {
          fontSize: "1.25rem",
          fontWeight: 700,
          color: theme.palette.primary.contrastText,
        },
        chipContainer: {
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          position: "absolute",
          padding: "5px 8px",
          zIndex: 1,
        },
        highlightTextChip: {
          height: "32px",
          display: "flex",
          padding: theme.spacing(0.5, 1.5),
          color: theme.palette.primary.contrastText,
          fontWeight: 700,
          marginRight: "auto",
          background: "linear-gradient(0deg, #AC8700 0%, #BA9B2A 88.96%)",
        },
        locationInfo: {
          maxWidth: "180px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 1,
          WebkitBoxOrient: "vertical",
        },
        durationContainer: {
          "& .MuiTypography-root": {
            fontSize: "1rem",
          },
        },
        cardContentStack: {},
      },
    },
    VerticalEventCard: {
      styleOverrides: {
        root: {
          width: "384px",
          minHeight: "786px",
          background:
            "linear-gradient(180deg, #FFFFFF 71%, #EDEEEE 100%) padding-box, linear-gradient(333deg, #D6C380 30%, #EEE7CC 81.85%) border-box",
          border: "1px solid transparent",
          borderRadius: "24px",
          boxShadow: "none",
          display: "flex",
          flexDirection: "column",
        },
        cardMedia: {
          width: "384px",
          height: "636px",
          objectFit: "cover",
          position: "relative",
        },
        duration: {
          color: "#948A8D",
          fontSize: "1rem",
          margin: 0,
        },
        cardTitle: {
          color: "#56464A",
          height: "56px",
          lineHeight: 1.3,
          fontWeight: 600,
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
          wordBreak: "break-word",
          "&.MuiTypography-root": {
            fontSize: "1rem",
          },
        },
        cardContent: {
          padding: theme.spacing(2),
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          "&.MuiCardContent-root:last-child": {
            paddingBottom: 0,
          },
          "& .MuiTypography-root": {
            fontSize: "1rem",
          },
        },
        cardInfoContainer: {
          height: 42,
          position: "relative",
          marginTop: "8px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          "& .MuiTypography-root": {
            fontSize: "1rem",
            color: "#948A8D",
          },
        },
        venueLogoContainer: {
          display: "flex",
          position: "absolute",
          margin: theme.spacing(1.5, 2),
          bottom: 0,
          right: 0,
          "& .MuiCardMedia-root": {
            maxWidth: "90px",
            maxHeight: "43px",
          },
        },
        iconContainer: {
          width: "auto",
          marginRight: theme.spacing(1),
          "& .MuiSvgIcon-root": {
            height: "24px",
            width: "24px",
            color: theme.palette.primary.main,
          },
        },
        statusTextContainer: {
          width: "100%",
          backgroundColor: "#EFBB00",
          position: "absolute",
          padding: theme.spacing(0.75, 1.5),
          bottom: 0,
          left: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "52px",
        },
        statusText: {
          fontSize: "1.25rem",
          fontWeight: 700,
          color: theme.palette.primary.contrastText,
        },
        chipContainer: {
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          position: "absolute",
          padding: "5px 8px",
          zIndex: 1,
        },
        highlightTextChip: {
          height: "32px",
          display: "flex",
          padding: theme.spacing(0.5, 1.5),
          color: theme.palette.primary.contrastText,
          fontWeight: 700,
          marginRight: "auto",
          background: "linear-gradient(0deg, #AC8700 0%, #BA9B2A 88.96%)",
        },
        locationInfo: {
          maxWidth: "180px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 1,
          WebkitBoxOrient: "vertical",
        },
        durationContainer: {
          "& .MuiTypography-root": {
            fontSize: "1rem",
          },
        },
        cardContentStack: {},
      },
    },
    ComingSoonChip: {
      styleOverrides: {
        root: {
          marginLeft: "auto",
          padding: theme.spacing(0.5, 1.5),
          height: "26px",
          borderRadius: "24px",
          backgroundColor: "#EFBB00",
          "& .MuiChip-label": {
            padding: theme.spacing(0),
            fontSize: "0.875rem",
            fontWeight: 400,
            color: theme.palette.primary.contrastText,
            textTransform: "uppercase",
          },
        },
      },
    },
    NewShopChip: {
      styleOverrides: {
        root: {
          marginLeft: "auto",
          padding: theme.spacing(0.5, 1.5),
          height: "26px",
          borderRadius: "24px",
          backgroundColor: "#F03D3D",
          "& .MuiChip-label": {
            padding: 0,
            fontSize: "0.875rem",
            fontWeight: 400,
            color: theme.palette.primary.contrastText,
            textTransform: "uppercase",
          },
        },
      },
    },
    VatRefundChip: {
      styleOverrides: {
        root: {
          background:
            "linear-gradient(89.59deg, #0ED065 54.18%, rgba(14, 208, 101, 0) 100%)",
          padding: theme.spacing(0.25, 3, 0.25, 1),
          height: "21px",
          borderRadius: 0,
          justifyContent: "flex-start",
          "& .MuiChip-label": {
            padding: 0,
            fontSize: "0.8125rem",
            fontWeight: 400,
            color: theme.palette.common.white,
          },
        },
      },
    },
    VuiSearchBasePopup: {
      styleOverrides: {
        dialog: {
          width: "100%",
          height: "100%",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          "& .MuiBackdrop-root": {
            borderRadius: 0,
          },
        },
        dialogPaper: {
          maxWidth: "1315px",
          alignSelf: "center",
          background: "none",
          boxShadow: "none",
          margin: theme.spacing(5),
          position: "relative",
          overflowY: "unset",
        },
        dialogContent: {
          padding: 0,
          "& .VuiSearchResult-root": {
            marginBottom: theme.spacing(1.5),
          },
          "& .VuiSearchPopupContent-closeButton": {
            display: "none",
          },
          "& .VuiSearchPopupContent-categoryFilterBar": {
            order: 3,
            marginBottom: theme.spacing(1.5),
          },
          "& .VuiSearchPopupContent-searchBar": {
            marginBottom: theme.spacing(1.5),
            position: "relative",
          },
          "& .VuiSearchPopupContent-searchBarInput": {
            height: "64px",
            padding: theme.spacing(1.5, 3),
            fontSize: "1.5rem",
            fontWeight: 400,
            "& .MuiInputAdornment-positionStart": {
              "& .MuiSvgIcon-root": {
                color: "#C6C5C9",
                fontSize: "1.875rem",
              },
            },
            "& .MuiInputAdornment-positionEnd": {
              width: "40px",
              height: "40px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            },
            "& .MuiInputAdornment-root": {
              "&.MuiInputAdornment-positionEnd": {
                "& .MuiSvgIcon-root": {
                  width: 12,
                  height: 12,
                  color: theme.palette.text.secondary,
                },
              },
            },
          },
          "& .VuiSearchKeyboard-root": {
            padding: 0,
            borderRadius: "32px",
          },
          "& .VuiSearchPopupContent-venueFilterContainer": {
            display: "flex",
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            bottom: "110px",
          },
          "& .VuiSearchPopupContent-closeButton--bottom": {
            display: "inline-flex",
            zIndex: 9999,
            background: "#F8F8FF",
            border: "1px solid #E2E2E4",
            width: "70px",
            height: "70px",
            borderRadius: "64px",
            position: "absolute",
            right: "-60px",
            top: "-10px",
            transform: "translateX(-50%)",
            "& .MuiSvgIcon-root": {
              width: "20px",
              height: "20px",
            },
            ":hover": {
              background: "#F8F8FF",
            },
          },
        },
      },
    },
    VuiOnscreenKeyboard: {
      styleOverrides: {
        root: {
          "& .simple-keyboard": {
            display: "flex",
            justifyContent: "center",
            padding: theme.spacing(3, 0),
            background:
              "linear-gradient(333deg, rgba(200, 175, 85, 0.20) 9.48%, rgba(238, 231, 204, 0.20) 69.55%), #F8F8FF",
            borderRadius: "32px",
            "&.hg-theme-default .hg-row": {
              marginBottom: "4px",
              "& .hg-button:not(:last-child)": {
                marginRight: "4px",
              },
            },
            "& .hg-button": {
              fontSize: "1.25rem",
              height: "52px",
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.primary.main,
              fontWeight: 700,
              borderRadius: "6px",
              border: "1px solid #E3D7AA",
            },
            "& .hg-primary-button": {
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.primary.main,
              fontWeight: 700,
              fontSize: "1rem",
            },
            "& .hg-secondary-button": {
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.primary.contrastText,
              fontWeight: 700,
            },
            "& .hg-row": {
              width: "604px",
              "& .hg-button-number": {
                flexGrow: 0.3,
                border: "none",
              },
              "& .hg-button-shift": {
                flexGrow: 1,
                border: "none",
              },
              "& .hg-button-bksp ": {
                flexGrow: 6,
                border: "none",
              },
              "& .hg-button-lang": {
                flexGrow: 1.5,
                fontSize: "1rem",
              },
              "& .hg-button-space": {
                flexGrow: 6,
              },
              "& .hg-button-enter": {
                flexGrow: 4,
              },
            },
            "& .hg-row:last-child .hg-button": {
              height: "40px",
            },
          },
        },
      },
    },
    VuiAdSuggestList: {
      defaultProps: {
        suggestBrandCarouselOptions: {
          autoplay: false,
          perPage: 9,
          gap: 0,
        },
      },
      styleOverrides: {
        root: {
          padding: theme.spacing(1.5, 2.5),
          borderRadius: "16px",
          border: "1px solid transparent",
          background:
            "linear-gradient(333deg, #F1EBD5 9.48%, #FCFBF5 69.55%) padding-box, linear-gradient(333deg, #C8AF55 31.92%, #EEE7CC 81.85%) border-box",
          marginBottom: theme.spacing(2.5),
          "[dir='rtl'] &": {
            background:
              "linear-gradient(333deg, #F1EBD5 90.52%, #FCFBF5 69.55%) padding-box, linear-gradient(333deg, #C8AF55 31.92%, #EEE7CC 81.85%) border-box",
          },
        },
        suggestTitle: {
          color: theme.palette.text.primary,
        },
        suggestList: {
          "& .splide__track": {
            padding: theme.spacing(1.5, 0),
          },
          "& .splide__pagination": {
            width: "fit-content",
            height: "8px",
            padding: 0,
            margin: "0 auto",
            backgroundColor: theme.palette.background.paper,
            display: "flex",
            justifyContent: "center",
            gap: 0,
            borderRadius: "32px",
          },
          "& .splide:not(.is-overflow) .splide__pagination": {
            display: "none",
          },
          "& .splide__pagination li": {
            height: "8px",
            margin: 0,
            padding: 0,
          },
          "& .splide__pagination__page": {
            width: "30px",
            height: "8px",
            borderRadius: "10px",
            backgroundColor: theme.palette.background.paper,
            display: "block",
            margin: 0,
          },
          "& .splide__pagination__page.is-active": {
            transform: "scale(1)",
            height: "8px",
            width: "30px",
            backgroundColor: theme.palette.primary.main,
            opacity: "1",
            display: "block",
            margin: 0,
          },
        },
        suggestListItem: {
          width: "110px",
        },
        suggestItemContent: {
          color: theme.palette.text.primary,
          "& .MuiTypography-root": {
            WebkitLineClamp: 1,
          },
        },
      },
    },
    VuiSearchResult: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.background.paper,
          marginTop: 0,
          borderRadius: "32px",
          "&:after": {
            height: "100px",
          },
          "[dir='rtl'] &:after": {
            background:
              "linear-gradient(180deg, transparent 72.39%, #fff 90.03%)",
          },
        },
        rootDialog: {
          height: "600px",
          padding: theme.spacing(5, 5, 1.25),
        },
        list: {
          gridTemplateColumns: "repeat(4, 1fr)",
          gridGap: theme.spacing(2.5),
        },
        listItem: {
          width: "293px",
          height: "150px",
        },
      },
    },
    HorizontalDirectoryOccupantCard: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "row",
          width: "293px",
          height: "150px",
          borderRadius: "8px",
          position: "relative",
          boxShadow: "none",
          border: "1px solid transparent",
          background:
            "linear-gradient(180deg, #FFFFFF 71%, #EDEEEE 100%, #FFF) padding-box, linear-gradient(333deg, #D6C380 30%, #EEE7CC 81.85%) border-box",
        },
        occupantLogo: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          boxShadow: "none",
          width: "150px",
          position: "relative",
          "& .MuiAvatar-root": {
            borderRadius: "0",
            width: "150px",
            height: "150px",
            "& .MuiSvgIcon-root": {
              width: "56px",
              height: "56px",
            },
          },
          "& .MuiAvatar-img": {
            objectFit: "cover",
          },
        },
        cardContent: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: theme.spacing(0.5, 1, 0, 1),
          height: "100%",
          width: "100%",
          "& .MuiTypography-root": {
            lineHeight: 1.3,
          },
        },
        levelAvatar: {
          width: 24,
          height: 24,
          fontSize: "0.7rem",
          fontWeight: 700,
          marginRight: theme.spacing(-0.5),
          color: theme.palette.primary.contrastText,
          background:
            "url(https://s3.venue.in.th/level_Icon_b460ba199f.svg) , no-repeat",
          backgroundSize: "cover",
        },
        divider: {
          display: "flex",
          borderBottomWidth: "1px",
          borderImage:
            "linear-gradient(291deg, #EEE7CC 0%, #AC8700 50%, #EEE7CC 100%) 1",
        },
        venueLogo: {
          objectFit: "contain",
          height: "100%",
          width: "45px",
        },
        titleText: {
          fontSize: "1rem",
          fontWeight: 700,
          flexGrow: 1,
          color: theme.palette.text.primary,
          maxHeight: "44px",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
          WebkitLineClamp: 2,
        },
        detailWrapper: {
          display: "flex",
          flexDirection: "column",
          height: "auto",
        },
        infoContainer: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: 0,
          alignItems: "center",
          height: "44px",
        },
        categoryText: {
          fontSize: "0.75rem",
          fontWeight: 300,
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          WebkitLineClamp: 1,
          color: "#6A6A6A",
          marginBottom: theme.spacing(1),
        },
        chipContainer: {
          display: "flex",
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          zIndex: 2,
          padding: "8px",
        },
        newShopChip: {
          height: "20px",
          marginRight: "auto",
          marginLeft: "unset",
          "& .MuiChip-label": {
            fontSize: "0.75rem",
          },
        },
        adsChip: {
          marginRight: "auto",
          padding: theme.spacing(1),
          height: "20px",
          borderRadius: "24px",
          backgroundColor: "rgba(73, 70, 86, 0.6)",
          "& .MuiChip-label": {
            padding: 0,
            fontSize: "0.75rem",
            fontWeight: 400,
            color: theme.palette.divider,
          },
        },
        comingSoonChip: {
          height: "20px",
          marginRight: "auto",
          marginLeft: "unset",
          "& .MuiChip-label": {
            fontSize: "0.75rem",
          },
        },
        vatRefundChip: {
          height: "20px",
          marginBottom: theme.spacing(0.5),
          "& .MuiChip-label": {
            fontSize: "0.75rem",
          },
        },
        firstSection: {
          height: "67px",
        },
        multiLevelContainer: {
          display: "flex",
          marginRight: theme.spacing(-0.5),
          "& > *:first-of-type": {
            borderRadius: "16px 0 0 16px",
            width: 26,
            paddingLeft: theme.spacing(0.25),
            borderRight: `0.4px solid ${theme.palette.divider}`,
          },
          "& > *:last-of-type": {
            borderRadius: "0 16px 16px 0",
            width: 26,
            paddingRight: theme.spacing(0.25),
          },
          "& > *:not(:first-of-type):not(:last-of-type)": {
            borderRadius: 0,
            borderRight: `0.4px solid ${theme.palette.divider}`,
          },
        },
        multiLevelAvatar: {
          width: 24,
          height: 24,
          fontSize: "0.7rem",
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: theme.palette.primary.contrastText,
          backgroundColor: theme.palette.primary.main,
        },
      },
    },
    HorizontalDirectorySkeletonCard: {
      styleOverrides: {
        root: {
          display: "flex",
          width: "293px",
          height: "150px",
        },
        avatar: {
          height: "100%",
          width: "100%",
          maxWidth: "150px",
        },
        cardContent: {
          padding: theme.spacing(1),
          display: "flex",
          flexDirection: "column",
          width: "100%",
          justifyContent: "space-between",
        },
      },
    },
    VerticalDirectionImageDialog: {
      styleOverrides: {
        root: {
          "&.VerticalDirectionImageDialog-root": {
            position: "fixed",
            zIndex: 1300,
            right: 655,
            bottom: 40,
            top: 40,
            left: 40,
          },
          "& .MuiBackdrop-root": {
            right: 655,
            bottom: 40,
            top: 40,
            left: 40,
            borderRadius: "32px",
          },
          "& .MuiPaper-elevation": {
            height: 276,
            maxWidth: 690,
            width: 668,
            borderRadius: "32px",
          },
        },
        container: {
          backgroundColor: theme.palette.background.paper,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: theme.spacing(4),
          padding: theme.spacing(6, 8),
        },
        image: {
          height: 180,
          width: 180,
        },
        descriptionContainer: {
          display: "flex",
          flexDirection: "column",
        },
        highlightedText: {
          fontWeight: 700,
          fontSize: "1rem",
        },
        headerContainer: {
          display: "flex",
          alignItems: "center",
          gap: theme.spacing(1),
        },
        primaryText: {
          fontSize: "2rem",
          fontWeight: 700,
          color: theme.palette.primary.main,
        },
        secondaryText: {
          fontSize: "1rem",
        },
        arrowIcon: {
          width: "32px",
          height: "32px",
        },
      },
    },
    FloorSelectionPanel: {
      styleOverrides: {
        root: {
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: theme.spacing(1.25),
          background: theme.palette.background.paper,
          borderRadius: "64px",
          boxShadow:
            "33px 36px 14px 0px rgba(0, 0, 0, 0.00), 21px 23px 13px 0px rgba(0, 0, 0, 0.01), 12px 13px 11px 0px rgba(0, 0, 0, 0.04), 5px 6px 8px 0px rgba(0, 0, 0, 0.06), 1px 1px 4px 0px rgba(0, 0, 0, 0.07)",
        },
        buttonWrapper: {
          flexDirection: "column",
          padding: theme.spacing(1.5),
          "& .MuiToggleButtonGroup-grouped": {
            borderRadius: "50%",
            "&:not(:first-of-type)": {
              borderRadius: "50%",
              margin: 0,
              border: `1px solid ${theme.palette.divider}`,
            },
            "&:first-of-type": {
              borderRadius: "50%",
              margin: 0,
              border: `1px solid ${theme.palette.divider}`,
            },
          },
        },
        floorButton: {
          width: 62,
          height: 62,
          borderRadius: "50%",
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.secondary,
          padding: 0,
          margin: 0,
          "&.Mui-selected": {
            background:
              "url(https://s3.venue.in.th/ordinal_button_pattern_9027ebd907.svg)",
            color: theme.palette.primary.contrastText,
            border: `2px solid ${theme.palette.primary.main}`,
          },
        },
        floorText: {
          fontSize: "1.5rem",
          fontWeight: 700,
          lineHeight: 1,
        },
      },
    },
    TouristRegistrationPanel: {
      styleOverrides: {
        root: {
          position: "absolute",
          left: 0,
          bottom: 40,
          zIndex: 1300,
          width: "64px",
          height: "231px",
          pointerEvents: "auto",
        },
        triggerPanel: {
          position: "relative",
          borderRadius: "0 16px 16px 0",
          backgroundColor: "#FFFE41",
          width: "64px",
          height: "231px",
          padding: "20px",
          backgroundSize: "auto",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundImage:
            "url('https://s3.venue.in.th/onesiam_visitor_vertical_logo_0eac82b10c.svg')",
          cursor: "pointer",
          boxShadow:
            "0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)",
          pointerEvents: "auto",
        },
        animationWrapper: {
          position: "absolute",
          top: 0,
          '[dir="rtl"] &': {
            left: 40,
          },
        },
        contentContainer: {
          width: "269px",
          height: "231px",
          borderRadius: "0px 16px 16px 0px",
          backgroundColor: theme.palette.background.paper,
          boxShadow:
            "0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)",
          overflow: "visible",
        },
        header: {
          width: "100%",
          height: "67px",
          backgroundColor: "#FFFE41",
          backgroundImage:
            "url('https://s3.venue.in.th/onesiam_visitor_horizontal_logo_3190eea5c5.svg')",
          backgroundSize: "auto",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          borderRadius: "0px 16px 0px 0px",
        },
        informationWrapper: {
          display: "flex",
          width: "100%",
          height: "164px",
          padding: theme.spacing(2.5),
          justifyContent: "space-between",
        },
        textContainer: { maxWidth: "126px", borderBottom: "1px solid #C6C5C9" },
        primaryText: {
          fontSize: "1.125rem",
          fontWeight: 700,
          color: "#0E0E0E",
        },
        secondaryText: {
          fontSize: "1.125rem",
          fontWeight: 400,
          color: "#0E0E0E",
        },
        tertiaryText: {
          fontSize: "0.875rem",
          fontWeight: 400,
          color: "#0E0E0E",
        },
        qrCodeContainer: {
          width: "78px",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
        },
        qrCode: {
          "&.AppQRCode-root": {
            border: "none",
            padding: 0,
            margin: 0,
            height: "100%",
            minHeight: "78px",
            boxShadow: "none",
            borderRadius: 0,
            justifyContent: "space-between",
          },
          "& .AppQRCode-content": {
            padding: 0,
            margin: 0,
            maxWidth: "78px",
            maxHeight: "78px",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
          },
          "& .AppQRCode-caption": {
            paddingTop: theme.spacing(2),
            fontSize: "0.875rem",
            textTransform: "none",
            fontWeight: 700,
          },
          "& .AppQRCode-secondary-caption": {
            display: "none",
          },
        },
        iconButton: {
          position: "absolute",
          top: "50%",
          transform: "translateY(-50%)",
          right: "-24px",
          backgroundColor: theme.palette.background.default,
          width: "24px",
          height: "32px",
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "0 8px 8px 0",
          color: theme.palette.text.secondary,
          padding: 0,
          "& .MuiSvgIcon-root": {
            width: "16px",
            height: "16px",
          },
        },
      },
    },
    SideBannerPanel: {
      styleOverrides: {
        root: {
          position: "absolute",
          left: 0,
          bottom: 40,
          zIndex: 1300,
          width: "64px",
          height: "231px",
          pointerEvents: "auto",
        },
        triggerPanel: {
          position: "relative",
          borderRadius: "0 16px 16px 0",
          backgroundColor: "#FFFE41",
          width: "64px",
          height: "231px",
          padding: "20px",
          backgroundSize: "auto",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundImage:
            "url('https://s3.venue.in.th/side_trigger_banner_f600b0a835.png')",
          cursor: "pointer",
          boxShadow:
            "0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)",
          pointerEvents: "auto",
        },
        animationWrapper: {
          position: "absolute",
          top: 0,
          '[dir="rtl"] &': {
            left: 40,
          },
        },
        contentContainer: {
          width: "269px",
          height: "231px",
          borderRadius: "0px 16px 16px 0px",
          backgroundColor: theme.palette.background.paper,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundImage:
            "url('https://s3.venue.in.th/side_banner_content_3c64c8a4b6.png')",
          boxShadow:
            "0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)",
          overflow: "visible",
        },
        iconButton: {
          position: "absolute",
          top: "50%",
          transform: "translateY(-50%)",
          right: "-24px",
          backgroundColor: theme.palette.background.default,
          width: "24px",
          height: "32px",
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "0 8px 8px 0",
          color: theme.palette.text.secondary,
          padding: 0,
          "& .MuiSvgIcon-root": {
            width: "16px",
            height: "16px",
          },
        },
      },
    },
    HomeInstructionCards: {
      styleOverrides: {
        root: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: theme.spacing(1.5),
          width: "100%",
          height: 440,
          background:
            "linear-gradient(270deg, rgba(238, 231, 204, 0) 2.25%, rgba(240, 235, 216, 0.9) 52.88%, rgba(238, 231, 204, 0) 100%)",
          "&:after": {
            content: "''",
            position: "absolute",
            width: "100%",
            height: "100%",
            backgroundImage:
              "url(https://s3.venue.in.th/iconsiam_mobile_touch_to_navigate_flare_41b77e49fb.svg)",
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            mixBlendMode: "screen",
            bottom: "-100px",
            pointerEvents: "none",
          },
        },
        card: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          width: "374px",
          height: "364px",
          borderRadius: "52px",
          background:
            "linear-gradient(348deg, #C8AF55 40.92%, #EEE7CC 121.39%)",
        },
        cardIcon: {
          width: 112,
          height: 112,
          color: theme.palette.primary.contrastText,
          "& .MuiSvgIcon-root": {
            width: "100%",
            height: "100%",
          },
        },
        cardLabel: {
          fontSize: "2.5rem",
          fontWeight: 700,
          color: theme.palette.primary.contrastText,
          textAlign: "center",
          textTransform: "none",
        },
        cardSubLabel: {
          fontSize: "1.75rem",
          color: theme.palette.primary.contrastText,
          textAlign: "center",
          whiteSpace: "pre-line",
        },
      },
    },
    HomeGuideCards: {
      styleOverrides: {
        root: {
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          alignContent: "center",
          justifyContent: "center",
          gap: "12px",
          width: "648px",
          height: "528px",
          "&:after": {
            content: "''",
            position: "absolute",
            width: "100%",
            height: "725px",
            backgroundImage:
              "url(https://s3.venue.in.th/background_homescreen_kiosk_h_91c08ba75b.png)",
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            mixBlendMode: "screen",
            zIndex: -1,
            top: 25,
            pointerEvents: "none",
          },
        },
        card: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: theme.spacing(1),
          width: "258px",
          height: "258px",
          aspectRatio: "1/1",
          padding: theme.spacing(2.125, 1.25),
          borderRadius: "40px",
          background:
            "linear-gradient(348deg, #C8AF55 40.92%, #EEE7CC 121.39%)",
        },
        cardIcon: {
          width: 108,
          height: 108,
          color: theme.palette.primary.contrastText,
          "& .MuiSvgIcon-root": {
            width: "100%",
            height: "100%",
          },
          "& .image-icon": {
            width: "100%",
            height: "100%",
          },
        },
        cardLabel: {
          fontSize: "1.725rem",
          lineHeight: 1.12,
          fontWeight: 700,
          color: theme.palette.primary.contrastText,
          textAlign: "center",
          textTransform: "none",
        },
        cardSubLabel: {
          fontSize: "1.2rem",
          lineHeight: 1.12,
          fontWeight: 500,
          color: theme.palette.primary.contrastText,
          textAlign: "center",
          whiteSpace: "pre-line",
        },
      },
    },
  },
})
